// ***** Add new features for price showing With service details (28-Oct-2025) ***** //
// import React, { useState, useEffect, useCallback } from "react";
// import { useParams, useNavigate, useOutletContext } from "react-router-dom";
// import axios from "axios";
// import { URL } from "../../config";
// import { createPortal } from "react-dom";
// import { 
//   FaDownload,
//   FaRegCommentDots,
//   FaUserSlash,
//   FaAmbulance,
//   FaTools,
//   FaMapMarkerAlt,
//   FaPen,
//   FaExclamationTriangle,
//   FaPhoneAlt,
//   FaLock,
//   FaLifeRing
//  } from "react-icons/fa";
// import ServitorReviewModal from "./ServitorReviewModal";
// import ServitorReceiptGenerator from "./ServitorReceipt/ServitorReceiptGenerator";
// // import { useNavigate } from 'react-router-dom';
// import { useTranslation } from "react-i18next";
// import "./ViewOrderDetails.css";
// import { serviceFields } from "../Services/serviceFields";
// import Loader from "../../Components/LoaderSpin/Loader";
// import { SERVICE_PRICING, AC_PRICING } from "../Services/servicePricing";

// const ViewOrderDetails = () => {
//   const { t } = useTranslation("servitor");

//   // const { servitor } = useOutletContext();
//   const { servitor, refreshServitor } = useOutletContext();

//   const { orderNumber } = useParams();
//   const navigate = useNavigate();
//   const [order, setOrder] = useState(null);
//   const [error, setError] = useState(null);

//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   // const [acceptedOrderId, setAcceptedOrderId] = useState(null);
//   const [pin, setPin] = useState("");
//   const [isPinVerified, setIsPinVerified] = useState(false);
//   const [verificationError, setVerificationError] = useState("");
//   const [showBusyModal, setShowBusyModal] = useState(false);
//   const [showErrorModal, setShowErrorModal] = useState(false);
//   const [errorModalMessage, setErrorModalMessage] = useState("");
//   const [showReviewModal, setShowReviewModal] = useState(false);

//   const [showCancelModal, setShowCancelModal] = useState(false);
//   // const [cancellationFeedback, setCancellationFeedback] = useState("");
//   const [selectedFeedbackOption, setSelectedFeedbackOption] = useState("");
//   const [otherFeedback, setOtherFeedback] = useState("");
//   const [feedbackError, setFeedbackError] = useState("");

//   const [showCancelSuccessModal, setShowCancelSuccessModal] = useState(false);
//   const [showWarningModal, setShowWarningModal] = useState(false);

//   const [showReceipt, setShowReceipt] = useState(false);

//   const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);

//   const [currentServitor, setCurrentServitor] = useState(servitor);
//   const [loading, setLoading] = useState(true);

//   const [showBlockedModal, setShowBlockedModal] = useState(false);
//   const [blockedMessage, setBlockedMessage] = useState("");

//   const isServitorBlocked =
//   String((currentServitor?.approve_status || servitor?.approve_status || "")).toLowerCase() === "blocked";


//   const [warningInfo, setWarningInfo] = useState(null);
//   const moneyTk = (n) => `${Math.ceil(Number(n || 0)).toLocaleString("en-BD")} tk`;


//   // Tutor helpers
//   const serviceName = order?.Service?.services_name;
//   const isTutor = serviceName === "Tutor Service";


//   // Normalize a phone number for the tel: link
//   const normalizeTel = (s) => (s ? String(s).replace(/[^+\d]/g, "") : "");

//   // Custom services helper (supports backend parsed customServices OR parses custom_service_json)
//   const getCustomItems = (order) => {
//     // prefer backend parsed array if exists
//     if (Array.isArray(order?.customServices)) return order.customServices;

//     // fallback: parse custom_service_json
//     const raw = order?.custom_service_json;
//     if (!raw) return [];

//     try {
//       const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
//       return Array.isArray(parsed) ? parsed : [];
//     } catch {
//       return [];
//     }
//   };



//   // Add authentication for view order details
//   // useEffect(() => {
//   //   const headers = {
//   //     Authorization: `Bearer ${localStorage.getItem("token")}`,
//   //   };

//   //   axios
//   //     .get(`${URL}/orders/byOrderNumber/${orderNumber}`, { headers })
//   //     .then((response) => {
//   //       setOrder(response.data);
//   //     })
//   //     .catch((err) => {
//   //       const status = err.response?.status;
//   //       if (status === 401) {
//   //         // token missing/expired → go back to login
//   //         // localStorage.removeItem('token');
//   //         // alert("Your session has expired. Please log in again.");
//   //         // return navigate('/login', { replace: true });

//   //         console.log("401 error detected, showing session expired modal");
//   //         localStorage.removeItem("token");
//   //         setShowSessionExpiredModal(true);
//   //       }
//   //       if (status === 403) {
//   //         // you’re not allowed to see this order → back to your list
//   //         return navigate("/servitor", { replace: true });
//   //       }
//   //       console.error("Error fetching order details:", err);
//   //       // setError("Error fetching order details.");
//   //       setError(t("viewOrderDetails.error"));
//   //     });
//   // }, [orderNumber, navigate, t]);

// // New added for refresh order automatic no need refresh windows
//   const refreshOrder = useCallback(async () => {
//   const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };

//   setLoading(true);
//   try {
//     const response = await axios.get(
//       `${URL}/orders/byOrderNumber/${orderNumber}`,
//       { headers }
//     );
//     setOrder(response.data);
//     setError(null);
//   } catch (err) {
//     const status = err.response?.status;
//     if (status === 401) {
//       localStorage.removeItem("token");
//       setShowSessionExpiredModal(true);
//     } else if (status === 403) {
//       navigate("/servitor", { replace: true });
//       return;
//     }
//     console.error("Error fetching order details:", err);
//     setError(t("viewOrderDetails.error"));
//   } finally {
//     setLoading(false);
//   }
// }, [orderNumber, navigate, t]);



//   // Add loader
//   // useEffect(() => {
//   //   let alive = true;
//   //   const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };

//   //   setLoading(true);

//   //   axios
//   //     .get(`${URL}/orders/byOrderNumber/${orderNumber}`, { headers })
//   //     .then((response) => {
//   //       if (!alive) return;
//   //       setOrder(response.data);
//   //       setError(null);
//   //     })
//   //     .catch((err) => {
//   //       if (!alive) return;
//   //       const status = err.response?.status;
//   //       if (status === 401) {
//   //         localStorage.removeItem("token");
//   //         setShowSessionExpiredModal(true);
//   //       } else if (status === 403) {
//   //         navigate("/servitor", { replace: true });
//   //         return;
//   //       }
//   //       console.error("Error fetching order details:", err);
//   //       setError(t("viewOrderDetails.error"));
//   //     })
//   //     .finally(() => {
//   //       if (!alive) return;
//   //       setLoading(false);
//   //     });

//   //   return () => {
//   //     alive = false;
//   //   };
//   // }, [orderNumber, navigate, t]);


//   // Initial load
//   useEffect(() => {
//     refreshOrder();
//   }, [refreshOrder]);




//   // const canViewPhone = ["Accepted", "In-Progress", "Completed"].includes(order?.status);
//   const canViewPhone = ["Accepted", "In-Progress"].includes(order?.status);

//   // useEffect(() => {
//   //   console.log("showSessionExpiredModal state:", showSessionExpiredModal);
//   // }, [showSessionExpiredModal]);

//   const handleSessionExpiredModalOk = () => {
//     // console.log("Session expired modal OK clicked, navigating to /login");
//     setShowSessionExpiredModal(false);
//     navigate("/login", { replace: true });
//   };

//   const handleBack = () => {
//     if (window.history.length > 1) {
//       navigate(-1);
//     } else {
//       navigate("/servitor");
//     }
//   };

//   const formatDate = (dateStr) => {
//   const d = new Date(dateStr);
//   const day = d.getDate();
//   const month = d.toLocaleString("default", { month: "long" });
//   const year = d.getFullYear();
//   return `${day}-${month}-${year}`;
// };

//   const SessionExpiredModal = () => {
//     console.log("Rendering session expired modal");
//     return createPortal(
//       <div className="servitorViewOrder-modal-overlay">
//         <div className="servitorViewOrder-modal-content">
//           {/* <h3>Session Expired</h3> */}
//           <h3>{t("viewOrderDetails.sessionExpiredTitle")}</h3>
//           {/* <p>
//             For your security, your session has expired. Please log in again to
//             continue using the app.
//           </p> */}
//           <p>{t("viewOrderDetails.sessionExpiredMessage")}</p>
//           <button
//             className="viewdetailsbtn ok-btn"
//             onClick={handleSessionExpiredModalOk}
//           >
//             {/* OK */}
//             {t("viewOrderDetails.ok")}
//           </button>
//         </div>
//       </div>,
//       document.body
//     );
//   };



//   // ------ Tutor service added new (21-8-25) ------ //

//   const handleAcceptOrder = async () => {
//   // If servitor is busy, show modal
//   if (servitor.availability === "busy") {
//     setShowBusyModal(true);
//     return;
//   }

//   if (isServitorBlocked) {
//     setShowBlockedModal(true);
//     setBlockedMessage(t("viewOrderDetails.accountBlockedMessage", { supportName: "HelpNao" }));
//     return;
//   }

//   const servitorId = servitor?.Id;
//   const service = order?.Service?.services_name;

//   // === TUTOR: no OTP at accept; call /tutor/:id/accept ===
//   if (service === "Tutor Service") {
//     try {

//       const MIN_AVAILABLE = 50;
//       const REQUIRED = 130;

//       // Use currentServitor if you just refreshed it elsewhere; fallback to servitor
//       const sc = currentServitor || servitor;
//       const currentPending = parseFloat(sc?.pendingCommission || servitor?.pendingCommission || 0);
//       const effectiveAvailable = parseFloat(servitor.balance || 0) - currentPending;

//       if ((effectiveAvailable - REQUIRED) < MIN_AVAILABLE) {
//         const need = (MIN_AVAILABLE + REQUIRED) - effectiveAvailable;
//         setWarningInfo({
//           need: Math.max(0, Math.ceil(need)),
//         });
//         setShowWarningModal(true);
//         return;
//       }

//       await axios.patch(
//         `${URL}/tutor/${order.Id}/accept`,
//         { servitor_id: servitorId },
//         { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
//       );

//       // (optional) refresh servitor balances in UI
//       const updatedServitorResponse = await axios.get(`${URL}/servitors/${servitorId}`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
//       });
//       setCurrentServitor(updatedServitorResponse.data);

//       setPin("");                 // no OTP yet for tutor
//       setIsPinVerified(false);
//       setShowSuccessModal(true);  // "accepted" success
//       return;
//     } catch (error) {
//       console.error("Error accepting tutor order:", error);
//       setErrorModalMessage(t("viewOrderDetails.orderAcceptFailed"));
//       setShowErrorModal(true);
//       return;
//     }
//   }

//   // === NON-TUTOR: keep 5% check + generate OTP as before ===
//   const BOOKING_FEE = 50;

//   // const estimatedCommission = order.price * 0.05;
//   const svc = String(order?.Service?.services_name || "").trim().toLowerCase();
//   const isAC = svc === "ac service";

//   const estimatedCommission = isAC
//     ? (Number(order.price) * 0.05) + BOOKING_FEE
//     : BOOKING_FEE;
    
//   const MIN_AVAILABLE = 50;
//   const currentPending = parseFloat(currentServitor?.pendingCommission || 0);
//   const effectiveAvailable = servitor.balance - currentPending;

//   if (effectiveAvailable - estimatedCommission < MIN_AVAILABLE) {
//     const need = (MIN_AVAILABLE + estimatedCommission) - effectiveAvailable;
//     setWarningInfo({
//       need: Math.max(0, Math.ceil(need)),
//     });
//     setShowWarningModal(true);
//     return;
//   }

//   try {
//     // generate prefixed OTP for non-tutor services
//     let prefix = "";
//     if (service === "Home Cleaning") prefix = "hs";
//     else if (service === "Electrician") prefix = "es";
//     else if (service === "Plumber") prefix = "ps";
//     else if (service === "Gas Chula") prefix = "gs";
//     else if (service === "AC Service") prefix = "as";
//     else if (service === "Filter") prefix = "fs";
//     else {
//       alert(t("viewOrderDetails.cancelNotAllowed"));
//       return;
//     }
//     const randomDigits = Math.floor(1000 + Math.random() * 9000).toString();
//     const generatedPin = prefix + randomDigits;

//     // build endpoint by service
//     let endpoint = "";
//     if (service === "Home Cleaning") endpoint = `${URL}/homeclean/${order.Id}`;
//     else if (service === "Electrician") endpoint = `${URL}/electrician/${order.Id}`;
//     else if (service === "Plumber") endpoint = `${URL}/plumber/${order.Id}`;
//     else if (service === "Gas Chula") endpoint = `${URL}/gaschula/${order.Id}`;
//     else if (service === "AC Service") endpoint = `${URL}/acservice/${order.Id}`;
//     else if (service === "Filter") endpoint = `${URL}/filter/${order.Id}`;

//     await axios.patch(
//       endpoint,
//       { status: "Accepted", servitor_id: servitorId, verification_pin: generatedPin },
//       { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
//     );

//     const updatedServitorResponse = await axios.get(`${URL}/servitors/${servitorId}`, {
//       headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
//     });
//     setCurrentServitor(updatedServitorResponse.data);

//     // setPin(generatedPin);
//     setPin("");
//     setIsPinVerified(false);
//     setShowSuccessModal(true);
//   } catch (error) {
//     console.error("Error accepting order:", error);
//     if (error.response?.status === 409) setErrorModalMessage(t("viewOrderDetails.orderAlreadyAccepted"));
//     else if (error.response?.status === 404) setErrorModalMessage(t("viewOrderDetails.orderNotAvailable"));
//     else setErrorModalMessage(t("viewOrderDetails.orderAcceptFailed"));
//     setShowErrorModal(true);
//   }
// };


// // ------------ Tutor service new -------------- //
//   const handleSubmitPin = async () => {
//   if (!pin.trim()) {
//     setVerificationError(t("viewOrderDetails.enterPinPlaceholder"));
//     return;
//   }
//   try {
//     const servitorId =
//       servitor?.Id ||
//       servitor?.id ||
//       order.Servitor?.Id ||
//       order.Servitor?.id;

//     const response = await axios.patch(
//       `${URL}/orders/${order.Id}/verify-pin`,
//       { pin, servitor_id: servitorId, serviceType: order.Service?.services_name },
//       { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
//     );

//     if (response.data.success) {
//       setIsPinVerified(true);
//       setShowSuccessModal(true);
//     } else {
//       setVerificationError(response.data.message || t("viewOrderDetails.invalidPin"));
//     }
//   } catch (error) {
//     const status = error.response?.status;
//     const data   = error.response?.data || {};

//     // >>> Place the refresh here, after showing the blocked modal
//     if (status === 403 && (data.errorType === "account_blocked" || /blocked/i.test(data.message || ""))) {
//       setShowBlockedModal(true);
//       setBlockedMessage(
//         t("viewOrderDetails.accountBlockedMessage", { supportName: "HelpNao" })
//       );
//       setVerificationError("");

//       // REFRESH SERVITOR PROFILE (so approve_status = "Blocked" in UI)
//       try {
//         const updated = await axios.get(
//           `${URL}/servitors/${servitor?.Id || servitor?.id}`,
//           { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
//         );
//         setCurrentServitor(updated.data);
//       } catch (e) {
//         // swallow
//       }

//       return; // <<< important
//     }
//     // <<< end of blocked branch

//     if (status === 400) {
//       const tries = Number(data.attemptsRemaining ?? 0);
//       if (Number.isFinite(tries) && tries >= 0) {
//         setVerificationError(
//           tries > 0
//             ? t("viewOrderDetails.invalidPinWithTries", { tries })
//             : t("viewOrderDetails.invalidPin")
//         );
//       } else {
//         setVerificationError(data.message || t("viewOrderDetails.invalidPin"));
//       }
//       return;
//     }

//     const msg = data?.message;
//     if (msg && msg.toLowerCase().includes("not approved")) {
//       setVerificationError(
//         t("viewOrderDetails.tutorNotApprovedYet") ||
//         "User has not approved this tutor yet. Ask the customer to approve first."
//       );
//       return;
//     }

//     setVerificationError(t("viewOrderDetails.invalidPin"));
//   }
// };

// // const refreshServitor = async () => {
// //   try {
// //     const updated = await axios.get(
// //       `${URL}/servitors/${servitor?.Id || servitor?.id}`,
// //       { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
// //     );
// //     setCurrentServitor(updated.data);
// //   } catch {}
// // };



//   // const handleModalOk = () => {
//   //   setShowSuccessModal(false);
//   //   window.location.reload();
//   //   // navigate('/servitor');
//   // };

//   const handleModalOk = () => {
//   setShowSuccessModal(false);
//   // window.location.reload(); 
//   refreshOrder();            //  refresh order data
//   refreshServitor?.();       //  refresh servitor header/balance if needed
// };


//   // const handleErrorModalOk = () => {
//   //   setShowErrorModal(false);
//   //   navigate("/servitor");
//   //   window.location.reload();
//   // };

//   const handleErrorModalOk = () => {
//     setShowErrorModal(false);
//     navigate("/servitor");
//     // window.location.reload(); //  not needed
//   };


//   const getOrderCity = (order) => {
//     // return order.City || order.usercity || "Unknown";
//     return order.City || order.usercity || t("viewOrderDetails.notProvided");
//   };

//   const getOrderArea = (order) => {
//     // return order.City || order.usercity || "Unknown";
//     return order.Area || order.userarea || t("viewOrderDetails.notProvided");
//   };

//   const getOrderAddress = (order) => {
//     // return order.Address || order.useraddress || "Unknown";
//     return order.Address || order.useraddress || t("viewOrderDetails.notProvided");
//   };

//   // Instead of immediate alert, open the cancel confirmation modal.
//   const handleCancelOrder = () => {
//     // Only allow cancellation if order is Accepted or In-Progress
//     if (order.status === "Accepted" || order.status === "In-Progress") {
//       setShowCancelModal(true);
//     } else {
//       // alert("Cancellation is not allowed at this stage.");
//       alert(t("viewOrderDetails.cancelNotAllowed"));
//     }
//   };

//   const handleConfirmCancel = async () => {

//     // Validate feedback selection
//     if (!selectedFeedbackOption) {
//       setFeedbackError(t("viewOrderDetails.feedbackError.selectFeedback"));
//       return;
//     }

//     // If "other", ensure textarea is not empty
//     if (selectedFeedbackOption === "other" && !otherFeedback.trim()) {
//       setFeedbackError(t("viewOrderDetails.feedbackError.writeFeedback"));
//       return;
//     }

//     // Get final feedback
//     const finalFeedback = selectedFeedbackOption === "other"
//       ? otherFeedback
//       : feedbackOptions.find((opt) => opt.id === selectedFeedbackOption)?.label || "";

//     try {
//       const servitorId =
//         servitor?.Id ||
//         servitor?.id ||
//         order.Servitor?.Id ||
//         order.Servitor?.id;
//       // const cancelEndpoint = `http://localhost:4001/orders/${order.Id}/cancel`;
//       const cancelEndpoint = `${URL}/orders/${order.Id}/cancel`;
//       await axios.patch(cancelEndpoint, {
//         serviceType: order.Service?.services_name,
//         cancellation_feedback: finalFeedback,
//         penalty: 50,
//         servitor_id: servitorId,
//       }, 
//       { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
//       );
//       // console.log("Order cancelled:", cancelEndpoint);
//       setShowCancelModal(false);
//       setShowCancelSuccessModal(true);
//     } catch (error) {
//       console.error("Error cancelling order:", error);
//       alert("Failed to cancel order. Please try again.");
//       setShowCancelModal(false);

//       // setErrorModalMessage(
//       //   error.response?.data?.message ||
//       //     "Failed to cancel order. Please try again."
//       // );
//       setErrorModalMessage(
//         error.response?.data?.message || t("viewOrderDetails.orderAcceptFailed") // NEW: Translated
//       );
//       setShowErrorModal(true);
//     }
//   };

//     const feedbackOptions = [
//     {
//       id: "customer_unavailable",
//       label: t("viewOrderDetails.feedbackOptions.customerUnavailable"),
//       // icon: "🚫",
//       icon: <FaUserSlash />,
//       bgColor: "#FEE2E2",
//       borderColor: "#FECACA",
//       textColor: "#991B1B",
//     },
//     {
//       id: "personal_emergency",
//       label: t("viewOrderDetails.feedbackOptions.personalEmergency"),
//       // icon: "⚠️",
//       icon: <FaAmbulance />,
//       bgColor: "#FEF3C7",
//       borderColor: "#FDE68A",
//       textColor: "#92400E",
//     },
//     {
//       id: "service_mismatch",
//       label: t("viewOrderDetails.feedbackOptions.serviceMismatch"),
//       // icon: "🔧",
//       icon: <FaTools />,
//       bgColor: "#DBEAFE",
//       borderColor: "#BFDBFE",
//       textColor: "#1E3A8A",
//     },
//     {
//       id: "location_issue",
//       label: t("viewOrderDetails.feedbackOptions.locationIssue"),
//       // icon: "📍",
//       icon: <FaMapMarkerAlt />,
//       bgColor: "#E0F2FE",
//       borderColor: "#BAE6FD",
//       textColor: "#0C4A6E",
//     },
//     {
//       id: "other",
//       label: t("viewOrderDetails.feedbackOptions.other"),
//       // icon: "✍️",
//       icon: <FaPen />,
//       bgColor: "#F3F4F6",
//       borderColor: "#E5E7EB",
//       textColor: "#374151",
//     },
//   ];

//   // Handler for closing cancel modal without confirming
//   const handleCancelModalClose = () => {
//     setShowCancelModal(false);
//   };



//   /* ----------------------------- pricing key maps ----------------------------- */
// // Electrician: boolean flat field name
// const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };

// // Plumber
// const MAP_PLUMBER = {
//   angle_valve_setup: "angleValveSetup",
//   basin_tap_setup: "basinTapSetup",
//   magic_pipe_setup: "magicPipeSetup",
//   basin_waste_pop_up_setup: "basinWastePopUpSetup",
//   new_basin_setup_existing_lines: "newBasinSetupExistingLines",

//   bathroom_tap_bib_cock_setup: "bathroomTapBibCockSetup",
//   tissue_holder_setup: "tissueHolderSetup",
//   fill_valve_replacement: "fillValveReplacement",
//   hand_shower_setup: "handShowerSetup",
//   soap_dish_setup: "soapDishSetup",
//   bathroom_shelf_setup: "bathroomShelfSetup",
//   mirror_setup: "mirrorSetup",
//   towel_hanger_setup: "towelHangerSetup",
//   shower_head_setup: "showerHeadSetup",
//   concealed_stopcock_setup: "concealedStopcockSetup",
//   floor_drain_net_setup: "floorDrainNetSetup",

//   toilet_seat_cover_replacement: "toiletSeatCoverReplacement",
//   toilet_seat_complete_installation: "toiletSeatCompleteInstallation",
//   high_commode_installation_existing_lines: "highCommodeInstallationExistingLines",
//   blockage_clearing_high_commode: "blockageClearingHighCommode",
//   blockage_clearing_low_commode: "blockageClearingLowCommode",

//   bathroom_drain_line_cleaning: "bathroomDrainLineCleaning",
//   geyser_installation: "geyserInstallation",

//   kitchen_sink_setup_existing_lines: "kitchenSinkSetupExistingLines",
//   sink_blockage_cleaning: "sinkBlockageCleaning",
//   washing_machine_point_setup: "washingMachinePointSetup",
// };
// const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };

// // Gas Chula
// const MAP_GAS = {
//   NewchulaSetup: "newChulaSetup",
//   chulaSetup: "chulaSetup",
//   burnerSetup: "burnerSetup",
//   burnerCleaning: "burnerCleaning",
//   nozzleReplacement: "nozzleReplacement",
// };
// const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };

// // Filter
// const MAP_FILTER = {
//   new_filter_setup: "newFilterSetup",
//   installation_filter: "installationFilter",
//   uninstallation_filter: "uninstallationFilter",
//   kit_replacement: "kitReplacement",
//   pipe_leak_or_replace: "pipeLeakOrReplace",
//   full_servicing: "fullServicing",
// };
// const FILTER_BOOL_FLAT = { check_up: "checkupFlat" };

// // Home Cleaning (first-free vs per-unit groups)
// const MAP_HOME_FIRSTFREE = { bed: "bedrooms", kitchen: "kitchens", dra_din: "drawingdinning" };
// const MAP_HOME_PERUNIT   = {
//   bath: "bathrooms", cloth: "cloths", dish: "dishes", balcony: "balconies",
//   window_grill: "windowGrills", furniture_cleaning: "furniture",
//   stairs_and_railing: "stairsFloors", carpet_cleaning: "carpets",
// };

// /* ----------------------------- money & AC helpers ----------------------------- */
// const money = (n) => `৳${Number(n || 0).toLocaleString("en-BD")}`;

// // AC rule: if qty===1 -> use `first`; if qty>=2 -> ALL units at `additional`
// const acPerUnitCost = (prop, qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return { total: 0, text: "" };
//   const rate = AC_PRICING?.perUnit?.[prop];
//   if (!rate) return { total: 0, text: "" };

//   if (c === 1) {
//     return { total: rate.first, text: `1 × ${rate.first}` };
//   }
//   const total = c * rate.additional;
//   return { total, text: `${c} × ${rate.additional}` };
// };

// // AC checkup: base covers up to `includesUnits`, extras are `extraPerUnit`
// const acCheckupCost = (qty) => {
//   const c = Math.max(0, Number(qty) || 0);
//   if (!c) return { total: 0, text: "" };
//   const { base = 0, includesUnits = 0, extraPerUnit = 0 } = AC_PRICING.checkup || {};
//   if (c <= includesUnits) {
//     return { total: base, text: `${c} unit${c > 1 ? "s" : ""} — ${base}` };
//   }
//   const over = c - includesUnits;
//   return { total: base + over * extraPerUnit, text: `${includesUnits} — ${base} + ${over} × ${extraPerUnit}` };
// };


 

//   // *** Updated renderServiceDetails function for has value Highlight ***

// //   const renderServiceDetails = () => {
// //   // 1) helper to decide whether to show a value
// //   const hasValue = (value) => {
// //     if (typeof value === "number") return value > 0;
// //     if (typeof value === "string") return value.toLowerCase() === "yes";
// //     return !!value;
// //   };

// //   // 2) helper to format (unit pluralization, booleans)
// //   const formatValue = (value, isBoolean = false) => {
// //     if (isBoolean)     return value ? "Yes" : "No";
// //     if (typeof value === "number") {
// //       return value === 1
// //         ? `1 ${t("viewOrderDetails.unit")}`
// //         : `${value} ${t("viewOrderDetails.units")}`;
// //     }
// //     return value;
// //   };

// //   // 3) Find the list of fields for this service
// //   const serviceName = order.Service?.services_name;
// //   const fields     = serviceFields[serviceName] || [];

// //   // 4) Derive the translation key segment ("homeCleaning", "plumber", ...)
// //   const keyMap = {
// //     "Home Cleaning": "homeCleaning",
// //     Plumber:         "plumber",
// //     Electrician:     "electrician",
// //     "Gas Chula":     "gasChula",
// //     "AC Service":    "acService",
// //     Filter:          "filter",
// //     "Tutor Service": "tutor",
// //   };
// //   const skey = keyMap[serviceName] || "";

// //   // 5) Title lookup: e.g. t("viewOrderDetails.services.homeCleaning.title")
// //   const title = t(`viewOrderDetails.services.${skey}.title`);

// //   return (
// //     <div className="service-details-card">
// //       <h3>{title}</h3>
// //       <div className="service-info-grid">
// //         {fields.map(({ prop, labelKey, type }, i) => {
// //           const raw = order[prop];
// //           // skip empty/zero/false
// //           if (type === "number"  && Number(raw) === 0) return null;
// //           if (type === "text"    && !raw)             return null;
// //           if (type === "boolean" && !raw)             return null;

// //           // compute display value
// //           const display = type === "boolean"
// //             ? formatValue(raw, true)
// //             : type === "number"
// //               ? formatValue(raw)
// //               : raw;

// //           return (
// //             <div
// //               key={i}
// //               className={`detail-box ${hasValue(raw) ? "has-value" : ""}`}
// //             >
// //               <div className="detail-label">{t(labelKey)}</div>
// //               <div className="detail-value">{display}</div>
// //             </div>
// //           );
// //         })}
// //       </div>
// //     </div>
// //   );
// // };


// const renderServiceDetails = () => {
//   // unit label helper
//   const u = (n) =>
//     Number(n) === 1 ? t("viewOrderDetails.unit") : t("viewOrderDetails.units");

//   // service context
//   const serviceName = order.Service?.services_name;
//   const fields = serviceFields[serviceName] || [];
//   const svcPricing = SERVICE_PRICING[serviceName] || {};

//   const keyMap = {
//     "Home Cleaning": "homeCleaning",
//     Plumber: "plumber",
//     Electrician: "electrician",
//     "Gas Chula": "gasChula",
//     "AC Service": "acService",
//     Filter: "filter",
//     "Tutor Service": "tutor",
//   };
//   const skey = keyMap[serviceName] || "";
//   const title = t(`viewOrderDetails.services.${skey}.title`);

//   // --- pricing text + totals for each field (null if not billable) ---
//   const getPriceInfo = (prop, type, raw) => {
//     // skip empties
//     if (type === "number" && Number(raw) === 0) return null;

//     // ELECTRICIAN
//     if (serviceName === "Electrician") {
//       if (typeof raw === "boolean") {
//         if (!raw) return null;
//         const flatKey = ELEC_BOOL_FLAT[prop];
//         const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//         if (!flat) return null;
//         return { total: flat, text: `1 ${u(1)} × ${flat}` };
//       }
//       const qty = Number(raw || 0);
//       if (qty <= 0) return null;
//       const rate = svcPricing?.perUnit?.[prop];
//       // if (!Number.isFinite(rate)) return null;
//       // return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
//       if (typeof rate === "number") {
//         if (!Number.isFinite(rate) || rate <= 0) return null;
//         return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
//       }

//       // drill-hole style pricing: { first, additional }
//       if (rate && typeof rate === "object") {
//         const first = Number(rate.first ?? 0);
//         const additional = Number(rate.additional ?? rate.first ?? 0);
//         if (!first && !additional) return null;

//         const total = first + Math.max(0, qty - 1) * additional;

//         const text =
//           qty === 1
//             ? `1 ${u(1)} × ${first}`
//             : `1 ${u(1)} × ${first} + (${qty - 1} ${u(qty - 1)} × ${additional})`;

//         return { total, text };
//       }

//       return null;
//     }

//     // PLUMBER
//     if (serviceName === "Plumber") {
//       if (typeof raw === "boolean") {
//         if (!raw) return null;
//         const flatKey = PLUMBER_BOOL_FLAT[prop];
//         const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//         if (!flat) return null;
//         return { total: flat, text: `1 ${u(1)} × ${flat}` };
//       }
//       const qty = Number(raw || 0);
//       if (qty <= 0) return null;
//       const puKey = MAP_PLUMBER[prop];
//       const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
//       if (!rate) return null;
//       return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
//     }

//     // GAS CHULA
//     if (serviceName === "Gas Chula") {
//       if (typeof raw === "boolean") {
//         if (!raw) return null;
//         const flatKey = GAS_BOOL_FLAT[prop];
//         const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//         if (!flat) return null;
//         return { total: flat, text: `1 ${u(1)} × ${flat}` };
//       }
//       const qty = Number(raw || 0);
//       if (qty <= 0) return null;
//       const puKey = MAP_GAS[prop];
//       const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
//       if (!rate) return null;
//       return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
//     }

//     // FILTER
//     if (serviceName === "Filter") {
//       if (typeof raw === "boolean") {
//         if (!raw) return null;
//         const flatKey = FILTER_BOOL_FLAT[prop];
//         const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
//         if (!flat) return null;
//         return { total: flat, text: `1 ${u(1)} × ${flat}` };
//       }
//       const qty = Number(raw || 0);
//       if (qty <= 0) return null;
//       const puKey = MAP_FILTER[prop];
//       const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
//       if (!rate) return null;
//       return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
//     }

//     // HOME CLEANING
//     if (serviceName === "Home Cleaning") {
//       const qty = Number(raw || 0);
//       if (qty <= 0) return null;

//       // first-free group
//       const ffKey = MAP_HOME_FIRSTFREE[prop];
//       if (ffKey && svcPricing?.firstFree?.[ffKey]) {
//         const perAdditional = svcPricing.firstFree[ffKey].perAdditional || 0;
//         const chargeable = Math.max(0, qty - 1);
//         const text =
//           chargeable > 0
//             ? `${chargeable} ${u(chargeable)} × ${perAdditional} (1st included)`
//             : `0 ${u(0)} × ${perAdditional} (1st included)`;
//         return { total: chargeable * perAdditional, text };
//       }

//       // straight per-unit
//       const puKey = MAP_HOME_PERUNIT[prop];
//       const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
//       if (!rate) return null;
//       return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
//     }

//     // AC SERVICE (use helpers so they’re not “unused”)
//     if (serviceName === "AC Service") {
//       if (
//         [
//           "installation_outdoor_inside",
//           "installation_outdoor_outside",
//           "uninstallation_outdoor_inside",
//           "uninstallation_outdoor_outside",
//           "cleaning_outdoor_inside",
//           "cleaning_outdoor_outside",
//         ].includes(prop)
//       ) {
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;
//         return acPerUnitCost(prop, qty); // -> { total, text }
//       }

//       if (prop === "issue_checkup") {
//         const qty = Number(raw || 0);
//         if (qty <= 0) return null;
//         return acCheckupCost(qty); // -> { total, text }
//       }

//       // descriptors (acType, acTon, remarks) are non-billable
//       return null;
//     }

//     return null;
//   };

//   return (
//     <div className="service-details-card">
//       <h3>{title}</h3>
//       <div className="service-info-grid">
//         {fields.map(({ prop, labelKey, type }, i) => {
//           const raw = order[prop];

//           // skip empty
//           if (type === "number" && Number(raw) === 0) return null;
//           if (type === "text" && !raw) return null;
//           if (type === "boolean" && !raw) return null;

//           const priceInfo = getPriceInfo(prop, type, raw); // { total, text } | null

//           return (
//             <div key={i} className={`detail-box ${priceInfo ? "has-value" : ""}`}>
//               <div className="detail-label">{t(labelKey)}</div>

//               {priceInfo ? (
//                 <div className="detail-price">
//                   {priceInfo.text} = <strong>{money(priceInfo.total)}</strong>
//                 </div>
//               ) : (
//                 <div className="detail-value">
//                   {type === "boolean" ? (raw ? "Yes" : "No") : String(raw)}
//                 </div>
//               )}
//             </div>
//           );
//         })}

//         {/* Custom services (from custom_service_json) */}
//         {getCustomItems(order).map((c, idx) => {
//           const name = String(c?.name || "").trim();
//           const price = Number(c?.price || 0);
//           if (!name) return null;

//           return (
//             <div key={`custom-${idx}`} className="detail-box has-value">
//               <div className="detail-label">Custom Service</div>
//               <div className="detail-price">
//                 {name} = <strong>{money(price)}</strong>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };



//   // const [showReviewModal, setShowReviewModal] = useState(false);
//   const handleOpenReviewModal = () => setShowReviewModal(true);
//   const handleCloseReviewModal = () => setShowReviewModal(false);

//   // if (error) return <p>{error}</p>;
//   // if (!order) return <p>Loading order details...</p>;

//   return (
//     <div className="container">
//       <Loader show={loading} />
//       {showSessionExpiredModal && <SessionExpiredModal />}
//       { !loading && error && !showSessionExpiredModal && <p>{error}</p>}
//       {/* {!error && !order && <p>Loading order details...</p>} */}
//       {/* {!error && !order && <p>{t("viewOrderDetails.loading")}</p>} */}
//       {order && (
//         <>
//           <div className="header">
//             {/* <h2>Order Details</h2> */}
//             <h2>{t("viewOrderDetails.heading")}</h2>
//             {/* <span className="order-id">Order ID: {order.Id}</span> */}
//             {/* <span className="order-id">Order Number: {order.order_number}</span> */}

//             <span className="order-id">
//               {t("viewOrderDetails.orderNumber")}: {order.order_number}
//             </span>
//           </div>

//           <div className="servitororderview-main-content">
//             <div className="card customer-info">
//               {/* <h3>Customer Information</h3> */}
//               <h3>{t("viewOrderDetails.customerInfo")}</h3>
//               <div className="info-content">
//                 <div className="info-row">
//                   {/* <span>Name: </span> */}
//                   <span>{t("viewOrderDetails.name")}: </span>
//                   <span>{`${order.User?.FirstName || "Not provided"} ${
//                     order.User?.LastName || ""
//                   }`}</span>
//                 </div>
//                 {/* <div className="info-row">
//                   <span>{t("viewOrderDetails.mobile")}: </span>
//                   <span>{order.User?.mobile || "Not provided"}</span>
//                 </div> */}

//                 <div className="info-row">
//                   <span>{t("viewOrderDetails.mobile")}: </span>

//                   {canViewPhone && order?.User?.mobile ? (
//                     <span className="phone-cell">
//                       <span className="phone-number">{order.User.mobile}</span>
//                       <a
//                         className="call-btn"
//                         href={`tel:${normalizeTel(order.User.mobile)}`}
//                         aria-label={t("viewOrderDetails.callCustomer")}
//                         title={t("viewOrderDetails.callCustomer")}
//                       >
//                         <FaPhoneAlt />
//                         <span className="call-text">{t("viewOrderDetails.call")}</span>
//                       </a>
//                     </span>
//                   ) : (
//                     <span className="phone-hidden">
//                       <FaLock className="lock-icon" />
//                       <span className="phone-hidden-text">
//                         {t("viewOrderDetails.phoneHiddenUntilAccept")}
//                       </span>
//                     </span>
//                   )}
//                 </div>


//                 <div className="info-row">
//                   {/* <span>City: </span> */}
//                   <span>{t("viewOrderDetails.city")}: </span>
//                   <span>{getOrderCity(order) || "Not provided"}</span>
//                 </div>
//                 <div className="info-row">
//                   {/* <span>City: </span> */}
//                   <span>{t("viewOrderDetails.area")}: </span>
//                   <span>{getOrderArea(order) || "Not provided"}</span>
//                 </div>
//                 <div className="info-row">
//                   {/* <span>Address: </span> */}
//                   <span>{t("viewOrderDetails.address")}: </span>
//                   <span>{getOrderAddress(order) || "Not provided"}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="card order-info">
//               {/* <h3>Order Information</h3> */}
//               <h3>{t("viewOrderDetails.orderInfo")}</h3>
//               <div className="info-content">
//                 <div className="info-row">
//                   {/* <span>Service: </span> */}
//                   <span>{t("viewOrderDetails.service")}: </span>
//                   <span>{order.Service?.services_name}</span>
//                 </div>
//                 <div className="info-row">
//                   {/* <span>Price: </span> */}
//                   <span>{t("viewOrderDetails.price")}: </span>
//                   <span className="price">{order.price} Tk.</span>
//                 </div>
//                 <div className="info-row">
//                   {/* <span>Date: </span> */}
//                   <span>{t("viewOrderDetails.date")}: </span>
//                   {/* <span>{new Date(order.date).toLocaleDateString()}</span> */}
//                   <span>{formatDate(order.date)}</span>
//                 </div>
//                 <div className="info-row">
//                   {/* <span>Time: </span> */}
//                   <span>{t("viewOrderDetails.time")}: </span>
//                   <span>{order.time}</span>
//                 </div>
//                 <div className="info-row">
//                   {/* <span>Status: </span> */}
//                   <span>{t("viewOrderDetails.status")}: </span>
//                   <span className={`status-badge ${order.status}`}>
//                     {order.status}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {renderServiceDetails()}

//           {/* {order.remarks && (
//             <div className="remarks-section">
//               <FaRegCommentDots className="remarks-icon" />
//               <span className="remarks-label">
//                 {t("viewOrderDetails.remarks")}:
//               </span>
//               <span className="remarks-text">{order.remarks}</span>
//             </div>
//           )} */}

//           {order.remarks && (
//             <div className="remarks-card">
//               <FaRegCommentDots className="remarks-icon" />
//               <p className="remarks-text">
//                 <strong>{t("viewOrderDetails.remarks")}: </strong>
//                 {order.remarks}
//               </p>
//             </div>
//           )}

//           {isTutor && order.status === "Accepted" && !order.user_approved && (
//             <div className="notice-card">
//               {/* {t("viewOrderDetails.tutorAwaitingApproval") ||
//                 "Waiting for user approval. OTP will be generated after the user approves you."} */}
//                 Waiting for user approval. OTP will be generated after the user approves you.
//             </div>
//           )}


//           {/* When order status is Accepted, show the PIN verification card */}
//           {order.status === "Accepted" && 
//           (serviceName !== "Tutor Service" || order.user_approved) && (
//             <div className="card verification-card">
//               {/* <h3>Start Work Verification</h3> */}
//               <h3>{t("viewOrderDetails.startWorkVerification")}</h3>
//               {/* <p>
//                 Please enter the verification PIN provided to you to start the
//                 task.
//               </p> */}
//               <p>{t("viewOrderDetails.startWorkMessage")}</p>
//               <input
//                 type="text"
//                 placeholder="Enter PIN"
//                 className="pin-input"
//                 value={pin}
//                 onChange={(e) => {
//                   setPin(e.target.value);
//                   setVerificationError("");
//                 }}
//                 aria-label={t("viewOrderDetails.enterPinPlaceholder")}
//               />
//               {verificationError && (
//                 <p style={{ color: "red" }}>{verificationError}</p>
//               )}
//               <button
//                 className="viewdetailsbtn submit-pin-btn"
//                 onClick={handleSubmitPin}
//                 aria-label={t("viewOrderDetails.submitPin")}
//               >
//                 {/* Submit PIN */}
//                 {t("viewOrderDetails.submitPin")}
//               </button>
//             </div>
//           )}

//           <div className="actions">
//             <button
//               className="viewdetailsbtn back-btn"
//               onClick={handleBack}
//               aria-label={t("viewOrderDetails.backToOrders")}
//             >
//               {/* ← Back to Orders */}← {t("viewOrderDetails.backToOrders")}
//             </button>
//             {/* When order status is not Accepted, show Accept Order button; otherwise show View Print button */}
//             {order.status === "pending" ? (
//               <button
//                 className="viewdetailsbtn accept-btn"
//                 // onClick={handleAcceptOrder}
//                 onClick={() => {
//                   // If servitor is busy then here show a modal message instead of accepting the order.
//                   if (servitor.availability === "busy") {
//                     setShowBusyModal(true);
//                   } else {
//                     handleAcceptOrder();
//                   }
//                 }}
//                 aria-label={t("viewOrderDetails.acceptOrder")}
//               >
//                 {/* Accept Order */}
//                 {t("viewOrderDetails.acceptOrder")}
//               </button>
//             ) : (
//               <div
//                 className="action-buttons"
//                 style={{ display: "flex", gap: "10px" }}
//               >
//                 <button
//                   className="viewdetailsbtn print-btn"
//                   onClick={() => setShowReceipt(true)}
//                   // style={{
//                   //   backgroundColor: "#007bff",
//                   //   color: "#fff",
//                   //   border: "none",
//                   //   borderRadius: "4px",
//                   //   padding: "10px 20px",
//                   //   cursor: "pointer",
//                   //   fontSize: "1rem",
//                   //   transition: "background-color 0.3s ease",
//                   // }}
//                   onMouseOver={(e) =>
//                     (e.currentTarget.style.backgroundColor = "#0069d9")
//                   }
//                   onMouseOut={(e) =>
//                     (e.currentTarget.style.backgroundColor = "#007bff")
//                   }
//                   aria-label={t("viewOrderDetails.receipt")}
//                 >
//                   {/* Print */}
//                   <FaDownload style={{ marginRight: "8px" }} />
//                   {/* Receipt */}
//                   {t("viewOrderDetails.receipt")}
//                 </button>

//                 {/* Cancel button appears if order is Accepted or In-Progress */}
//                 {(order.status === "Accepted" ||
//                   order.status === "In-Progress") && (
//                   <button
//                     className="viewdetailsbtn cancel-btn"
//                     onClick={handleCancelOrder}
//                     style={{
//                       backgroundColor: "#e74c3c",
//                       color: "#fff",
//                       border: "none",
//                       borderRadius: "4px",
//                       padding: "10px 20px",
//                       cursor: "pointer",
//                       fontSize: "1rem",
//                       transition: "background-color 0.3s ease",
//                     }}
//                     onMouseOver={(e) =>
//                       (e.currentTarget.style.backgroundColor = "#c0392b")
//                     }
//                     onMouseOut={(e) =>
//                       (e.currentTarget.style.backgroundColor = "#e74c3c")
//                     }
//                     aria-label={t("viewOrderDetails.cancel")}
//                   >
//                     {/* Cancel */}
//                     {t("viewOrderDetails.cancel")}
//                   </button>
//                 )}
//               </div>
//             )}

//             {/* If order is completed, show a Review & Feedback button for the servitor and check review is given or not*/}
//             {order.status === "Completed" && !order.hasReview && (
//               <button
//                 className="viewdetailsbtn review-btn"
//                 onClick={handleOpenReviewModal}
//                 aria-label={t("viewOrderDetails.rateCustomer")}
//               >
//                 {/* Review & Feedback */}
//                 {/* Rate the Customer */}
//                 {t("viewOrderDetails.rateCustomer")}
//               </button>
//             )}

//             {(order.status !== "pending") && ( 
//             <button
//               className="viewdetailsbtn help-btn"
//               onClick={() =>
//                 navigate(`/servitor/support/report/${order.order_number}`, {
//                   state: { serviceType: order.Service?.services_name },
//                 })
//               }
//             >
//               <FaLifeRing style={{ marginRight: "8px" }} />
//               {/* Help & Support */}
//               {t("viewOrderDetails.help_support") || "Help & Support"}
//             </button>
//             )}

//           </div>

//           {/* Busy modal  */}
//           {showBusyModal && (
//             <div className="servitorViewOrder-modal-overlay">
//               <div className="servitorViewOrder-modal-content">
//                 {/* <h3>Task In Progress</h3> */}
//                 <h3>{t("viewOrderDetails.taskInProgressTitle")}</h3>
//                 {/* <p>
//                   You are already working on an order. Please complete your
//                   current task to accept a new order.
//                 </p> */}

//                 <p>{t("viewOrderDetails.taskInProgressMessage")}</p>

//                 <button
//                   className="viewdetailsbtn ok-btn"
//                   onClick={() => setShowBusyModal(false)}
//                   aria-label={t("viewOrderDetails.ok")}
//                 >
//                   {/* OK */}
//                   {t("viewOrderDetails.ok")}
//                 </button>
//               </div>
//             </div>
//           )}

//           {showErrorModal && (
//             <div className="servitorViewOrder-modal-overlay">
//               <div className="servitorViewOrder-modal-content">
//                 {/* <h3>Order Unavailable</h3> */}
//                 <h3>{t("viewOrderDetails.orderUnavailableTitle")}</h3>
//                 <p>{errorModalMessage}</p>
//                 <button
//                   className="viewdetailsbtn ok-btn"
//                   onClick={handleErrorModalOk}
//                   aria-label={t("viewOrderDetails.ok")}
//                 >
//                   {/* OK */}
//                   {t("viewOrderDetails.ok")}
//                 </button>
//               </div>
//             </div>
//           )}

//           {showSuccessModal && (
//             <div className="servitorViewOrder-modal-overlay">
//               <div className="servitorViewOrder-modal-content">
//                 {/* <h3>Success</h3> */}
//                 <h3>{t("viewOrderDetails.successTitle")}</h3>
//                 {/* <p>Order ID {acceptedOrderId} has been accepted.</p> */}
//                 <p>
//                   {/* {t("viewOrderDetails.successMessage", {
//                     // orderId: acceptedOrderId,
//                     orderNumber: order?.order_number || "N/A",
//                   })} */}
//                   {t(
//                       isPinVerified
//                         ? "viewOrderDetails.successMessagePinVerified"
//                         : "viewOrderDetails.successMessage",
//                       {
//                         orderNumber: order?.order_number || "N/A",
//                       }
//                     )}
//                 </p>

//                 <button
//                   className="viewdetailsbtn ok-btn"
//                   onClick={handleModalOk}
//                   aria-label={t("viewOrderDetails.ok")}
//                 >
//                   {/* OK */}
//                   {t("viewOrderDetails.ok")}
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* Cancel Confirmation Modal */}
//           {showCancelModal && (
//             <div className="servitorViewOrderDetails-cancelation-modal-overlay">
//               <div className="servitorViewOrderDetails-cancelation-modal-content">
//                 <h3 className="servitorViewOrderDetails-cancelation-modal-title">
//                   {t("viewOrderDetails.confirmCancellationTitle")}
//                 </h3>
//                 {/* <p className="servitorViewOrderDetails-cancelation-modal-message">
//                   {t("viewOrderDetails.confirmCancellationMessage")}
//                 </p> */}

//                 <p className="servitorViewOrderDetails-cancelation-modal-message">
//                   <span className="servitorViewOrderDetails-cancelation-warning-icon">
//                     <FaExclamationTriangle />
//                   </span>
//                   <span>
//                     <strong>{t("viewOrderDetails.warningLabel")}</strong>:{" "}
//                     {t("viewOrderDetails.confirmCancellationMessage")}
//                   </span>
//                 </p>

//                 <h4 className="servitorViewOrderDetails-cancelation-feedback-prompt">
//                   {t("viewOrderDetails.feedbackPrompt")}
//                 </h4>

//                 {feedbackError && (
//                   <div className="servitorViewOrderDetails-cancelation-error-text">
//                     {feedbackError}
//                   </div>
//                 )}

//                 <div className="servitorViewOrderDetails-cancelation-feedback-grid">
//                   {feedbackOptions.slice(0, 4).map((option) => (
//                     <label
//                       key={option.id}
//                       className={`servitorViewOrderDetails-cancelation-feedback-option ${
//                         selectedFeedbackOption === option.id ? "selected" : ""
//                       }`}
//                       style={{
//                         backgroundColor:
//                           selectedFeedbackOption === option.id
//                             ? option.bgColor
//                             : "#fff",
//                         borderColor:
//                           selectedFeedbackOption === option.id
//                             ? option.borderColor
//                             : "#e5e7eb",
//                         color:
//                           selectedFeedbackOption === option.id
//                             ? option.textColor
//                             : "#374151",
//                       }}
//                       onClick={() => {
//                         setSelectedFeedbackOption(option.id);
//                         if (option.id !== "other") setOtherFeedback("");
//                         setFeedbackError("");
//                       }}
//                     >
//                       <input
//                         type="radio"
//                         name="feedback"
//                         value={option.id}
//                         checked={selectedFeedbackOption === option.id}
//                         readOnly
//                         className="servitorViewOrderDetails-cancelation-feedback-radio"
//                       />
//                       <span className="servitorViewOrderDetails-cancelation-option-icon">
//                         {option.icon}
//                       </span>
//                       <span className="servitorViewOrderDetails-cancelation-option-label">
//                         {option.label}
//                       </span>
//                     </label>
//                   ))}
//                 </div>

//                 <label
//                   className={`servitorViewOrderDetails-cancelation-feedback-option full-width ${
//                     selectedFeedbackOption === "other" ? "selected" : ""
//                   }`}
//                   style={{
//                     backgroundColor:
//                       selectedFeedbackOption === "other"
//                         ? feedbackOptions[4].bgColor
//                         : "#fff",
//                     borderColor:
//                       selectedFeedbackOption === "other"
//                         ? feedbackOptions[4].borderColor
//                         : "#e5e7eb",
//                     color:
//                       selectedFeedbackOption === "other"
//                         ? feedbackOptions[4].textColor
//                         : "#374151",
//                   }}
//                   onClick={() => {
//                     setSelectedFeedbackOption("other");
//                     setFeedbackError("");
//                   }}
//                 >
//                   <input
//                     type="radio"
//                     name="feedback"
//                     value="other"
//                     checked={selectedFeedbackOption === "other"}
//                     readOnly
//                     className="servitorViewOrderDetails-cancelation-feedback-radio"
//                   />
//                   <span className="servitorViewOrderDetails-cancelation-option-icon">
//                     {feedbackOptions[4].icon}
//                   </span>
//                   <span className="servitorViewOrderDetails-cancelation-option-label">
//                     {feedbackOptions[4].label}
//                   </span>
//                 </label>

//                 {selectedFeedbackOption === "other" && (
//                   <div className="servitorViewOrderDetails-cancelation-other-feedback-container">
//                     <label className="servitorViewOrderDetails-cancelation-other-feedback-label">
//                       {t("viewOrderDetails.feedbackOtherDetails")}
//                     </label>
//                     <textarea
//                       value={otherFeedback}
//                       onChange={(e) => setOtherFeedback(e.target.value)}
//                       placeholder={t(
//                         "viewOrderDetails.feedbackOtherPlaceholder"
//                       )}
//                       className="servitorViewOrderDetails-cancelation-textarea"
//                     />
//                   </div>
//                 )}

//                 <div className="servitorViewOrderDetails-cancelation-modal-actions">
//                   <button
//                     className="viewdetailsbtn servitorViewOrderDetails-cancelation-modal-cancel-btn"
//                     onClick={handleConfirmCancel}
//                     aria-label={t("viewOrderDetails.yesCancel")}
//                   >
//                     {t("viewOrderDetails.yesCancel")}
//                   </button>
//                   <button
//                     className="viewdetailsbtn servitorViewOrderDetails-cancelation-modal-back-btn"
//                     onClick={handleCancelModalClose}
//                     aria-label={t("viewOrderDetails.noGoBack")}
//                   >
//                     {t("viewOrderDetails.noGoBack")}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Warning Modal */}
//           {showWarningModal && (
//             <div className="servitorViewOrder-modal-overlay">
//               <div className="servitorViewOrder-modal-content">
//                 {/* <h3 style={{ color: "orange" }}>Warning!</h3> */}
//                 <h3 style={{ color: "orange" }}>
//                   {t("viewOrderDetails.warningTitle")}
//                 </h3>
//                 {/* <p>
//                   Accepting this order will reduce your available balance below
//                   the minimum required. Please top-up your account before
//                   accepting more orders.
//                 </p> */}
//                 <p>{t("viewOrderDetails.warningMessage",{ need: moneyTk(warningInfo.need) })}</p>
//                 {/* {t("viewOrderDetails.warningCombined", { need: moneyTk(warningInfo.need) })} */}
//                 <button
//                   className="viewdetailsbtn ok-btn"
//                   onClick={() => setShowWarningModal(false)}
//                 >
//                   {/* OK */}
//                   {t("viewOrderDetails.ok")}
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* Cancel Success Modal */}
//           {showCancelSuccessModal && (
//             <div className="servitorViewOrder-modal-overlay">
//               <div className="servitorViewOrder-modal-content">
//                 {/* <h3>Cancellation Successful</h3> */}
//                 <h3>{t("viewOrderDetails.cancellationSuccessfulTitle")}</h3>
//                 {/* <p>Your order has been cancelled.</p> */}
//                 <p>{t("viewOrderDetails.cancellationSuccessfulMessage")}</p>
//                 <button
//                   className="viewdetailsbtn ok-btn"
//                   // onClick={() => window.location.reload()}
//                   onClick={() => {
//                     setShowCancelSuccessModal(false);
//                     // window.location.reload(); // 
//                     refreshOrder();            //  update order status
//                     refreshServitor?.();       //  update balance/penalty etc.
//                   }}

//                   aria-label={t("viewOrderDetails.ok")}
//                 >
//                   {/* OK */}
//                   {t("viewOrderDetails.ok")}
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* Review & Feedback Modal for servitor */}
//           {showReviewModal && (
//             <ServitorReviewModal
//               order={order}
//               onClose={handleCloseReviewModal}
//               onReviewSubmit={() => {
//                 // After review submission, refresh the page or update UI accordingly.
//                 // window.location.reload();
//                 refreshOrder();
//               }}
//             />
//           )}

//           {showReceipt && (
//             <ServitorReceiptGenerator
//               order={order}
//               onFinish={() => setShowReceipt(false)}
//             />
//           )}
//         </>
//       )}

//       {showBlockedModal && (
//         <div className="servitorViewOrder-modal-overlay">
//           <div className="servitorViewOrder-modal-content">
//             <h3 style={{ color: "#e74c3c" }}>{t("viewOrderDetails.accountBlockedTitle")}</h3>
//             <p>{blockedMessage}</p>
//             <button
//               className="viewdetailsbtn ok-btn"
//               onClick={() => {
//                 setShowBlockedModal(false);
//                 // Optional: navigate to support or profile
//                 // navigate("/servitor/support");
//               }}
//               aria-label={t("viewOrderDetails.ok")}
//             >
//               {t("viewOrderDetails.ok")}
//             </button>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default ViewOrderDetails;







// ***** Lates Update for shwoing exact balance needed for accept order (21-January-2026) ***** //
import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import { URL } from "../../config";
import { createPortal } from "react-dom";
import { 
  FaDownload,
  FaRegCommentDots,
  FaUserSlash,
  FaAmbulance,
  FaTools,
  FaMapMarkerAlt,
  FaPen,
  FaExclamationTriangle,
  FaPhoneAlt,
  FaLock,
  FaLifeRing
 } from "react-icons/fa";
import ServitorReviewModal from "./ServitorReviewModal";
import ServitorReceiptGenerator from "./ServitorReceipt/ServitorReceiptGenerator";
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import "./ViewOrderDetails.css";
import { serviceFields } from "../Services/serviceFields";
import Loader from "../../Components/LoaderSpin/Loader";
import { SERVICE_PRICING, AC_PRICING } from "../Services/servicePricing";

const ViewOrderDetails = () => {
  const { t } = useTranslation("servitor");

  // const { servitor } = useOutletContext();
  const { servitor, refreshServitor } = useOutletContext();

  const { orderNumber } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState(null);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  // const [acceptedOrderId, setAcceptedOrderId] = useState(null);
  const [pin, setPin] = useState("");
  const [isPinVerified, setIsPinVerified] = useState(false);
  const [verificationError, setVerificationError] = useState("");
  const [showBusyModal, setShowBusyModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");
  const [showReviewModal, setShowReviewModal] = useState(false);

  const [showCancelModal, setShowCancelModal] = useState(false);
  // const [cancellationFeedback, setCancellationFeedback] = useState("");
  const [selectedFeedbackOption, setSelectedFeedbackOption] = useState("");
  const [otherFeedback, setOtherFeedback] = useState("");
  const [feedbackError, setFeedbackError] = useState("");

  const [showCancelSuccessModal, setShowCancelSuccessModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);

  const [showReceipt, setShowReceipt] = useState(false);

  const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);

  const [currentServitor, setCurrentServitor] = useState(servitor);
  const [loading, setLoading] = useState(true);

  const [showBlockedModal, setShowBlockedModal] = useState(false);
  const [blockedMessage, setBlockedMessage] = useState("");

  const isServitorBlocked =
  String((currentServitor?.approve_status || servitor?.approve_status || "")).toLowerCase() === "blocked";


  const [warningInfo, setWarningInfo] = useState(null);
  const moneyTk = (n) => `${Math.ceil(Number(n || 0)).toLocaleString("en-BD")} tk`;

  // ✅ Minimum balance rule (must keep at least 50 tk)
  const MIN_AVAILABLE = 50;

  // ✅ Commission/platform fee required to accept an order
  // const getRequiredCommissionForAccept = (order) => {
  //   // Prefer backend snapshots (new system)
  //   const snap = Number(order?.commission_amount ?? order?.platform_fee);

  //   if (Number.isFinite(snap) && snap > 0) return snap;

  //   // Fallback for old orders without snapshot fields
  //   const price = Number(order?.price || 0);
  //   const percentFee = Math.round(price * 0.05);
  //   return Math.max(50, percentFee); // min 50
  // };

  const getRequiredCommissionForAccept = (order) => {
    const snap = Number(order?.commission_amount ?? order?.platform_fee);
    if (Number.isFinite(snap) && snap > 0) return snap;
    return 50; // safe fallback for old orders
  };

  // ✅ Effective available balance = balance - pendingCommission
  // const getEffectiveAvailable = (sc) => {
  //   const bal = Number(sc?.balance || 0);
  //   const pending = Number(sc?.pendingCommission || 0);
  //   return bal - pending;
  // };
  const getEffectiveAvailable = (sc) => {
    const bal = Number(sc?.balance);
    const pending = Number(sc?.pendingCommission);
    const b = Number.isFinite(bal) ? bal : 0;
    const p = Number.isFinite(pending) ? pending : 0;
    return b - p;
  };


  // Tutor helpers
  const serviceName = order?.Service?.services_name;
  const isTutor = serviceName === "Tutor Service";


  // Normalize a phone number for the tel: link
  const normalizeTel = (s) => (s ? String(s).replace(/[^+\d]/g, "") : "");

  // Custom services helper (supports backend parsed customServices OR parses custom_service_json)
  const getCustomItems = (order) => {
    // prefer backend parsed array if exists
    if (Array.isArray(order?.customServices)) return order.customServices;

    // fallback: parse custom_service_json
    const raw = order?.custom_service_json;
    if (!raw) return [];

    try {
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };



  // Add authentication for view order details
  // useEffect(() => {
  //   const headers = {
  //     Authorization: `Bearer ${localStorage.getItem("token")}`,
  //   };

  //   axios
  //     .get(`${URL}/orders/byOrderNumber/${orderNumber}`, { headers })
  //     .then((response) => {
  //       setOrder(response.data);
  //     })
  //     .catch((err) => {
  //       const status = err.response?.status;
  //       if (status === 401) {
  //         // token missing/expired → go back to login
  //         // localStorage.removeItem('token');
  //         // alert("Your session has expired. Please log in again.");
  //         // return navigate('/login', { replace: true });

  //         console.log("401 error detected, showing session expired modal");
  //         localStorage.removeItem("token");
  //         setShowSessionExpiredModal(true);
  //       }
  //       if (status === 403) {
  //         // you’re not allowed to see this order → back to your list
  //         return navigate("/servitor", { replace: true });
  //       }
  //       console.error("Error fetching order details:", err);
  //       // setError("Error fetching order details.");
  //       setError(t("viewOrderDetails.error"));
  //     });
  // }, [orderNumber, navigate, t]);

// New added for refresh order automatic no need refresh windows
  const refreshOrder = useCallback(async () => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };

  setLoading(true);
  try {
    const response = await axios.get(
      `${URL}/orders/byOrderNumber/${orderNumber}`,
      { headers }
    );
    setOrder(response.data);
    setError(null);
  } catch (err) {
    const status = err.response?.status;
    if (status === 401) {
      localStorage.removeItem("token");
      setShowSessionExpiredModal(true);
    } else if (status === 403) {
      navigate("/servitor", { replace: true });
      return;
    }
    console.error("Error fetching order details:", err);
    setError(t("viewOrderDetails.error"));
  } finally {
    setLoading(false);
  }
}, [orderNumber, navigate, t]);



  // Add loader
  // useEffect(() => {
  //   let alive = true;
  //   const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };

  //   setLoading(true);

  //   axios
  //     .get(`${URL}/orders/byOrderNumber/${orderNumber}`, { headers })
  //     .then((response) => {
  //       if (!alive) return;
  //       setOrder(response.data);
  //       setError(null);
  //     })
  //     .catch((err) => {
  //       if (!alive) return;
  //       const status = err.response?.status;
  //       if (status === 401) {
  //         localStorage.removeItem("token");
  //         setShowSessionExpiredModal(true);
  //       } else if (status === 403) {
  //         navigate("/servitor", { replace: true });
  //         return;
  //       }
  //       console.error("Error fetching order details:", err);
  //       setError(t("viewOrderDetails.error"));
  //     })
  //     .finally(() => {
  //       if (!alive) return;
  //       setLoading(false);
  //     });

  //   return () => {
  //     alive = false;
  //   };
  // }, [orderNumber, navigate, t]);


  // Initial load
  useEffect(() => {
    refreshOrder();
  }, [refreshOrder]);




  // const canViewPhone = ["Accepted", "In-Progress", "Completed"].includes(order?.status);
  const canViewPhone = ["Accepted", "In-Progress"].includes(order?.status);

  // useEffect(() => {
  //   console.log("showSessionExpiredModal state:", showSessionExpiredModal);
  // }, [showSessionExpiredModal]);

  const handleSessionExpiredModalOk = () => {
    // console.log("Session expired modal OK clicked, navigating to /login");
    setShowSessionExpiredModal(false);
    navigate("/login", { replace: true });
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/servitor");
    }
  };

  const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  const day = d.getDate();
  const month = d.toLocaleString("default", { month: "long" });
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

  const SessionExpiredModal = () => {
    console.log("Rendering session expired modal");
    return createPortal(
      <div className="servitorViewOrder-modal-overlay">
        <div className="servitorViewOrder-modal-content">
          {/* <h3>Session Expired</h3> */}
          <h3>{t("viewOrderDetails.sessionExpiredTitle")}</h3>
          {/* <p>
            For your security, your session has expired. Please log in again to
            continue using the app.
          </p> */}
          <p>{t("viewOrderDetails.sessionExpiredMessage")}</p>
          <button
            className="viewdetailsbtn ok-btn"
            onClick={handleSessionExpiredModalOk}
          >
            {/* OK */}
            {t("viewOrderDetails.ok")}
          </button>
        </div>
      </div>,
      document.body
    );
  };



  // ------ Tutor service added new (21-8-25) ------ //

  const handleAcceptOrder = async () => {
  // If servitor is busy, show modal
  if (servitor.availability === "busy") {
    setShowBusyModal(true);
    return;
  }

  if (isServitorBlocked) {
    setShowBlockedModal(true);
    setBlockedMessage(t("viewOrderDetails.accountBlockedMessage", { supportName: "HelpNao" }));
    return;
  }

  const servitorId = servitor?.Id;
  const service = order?.Service?.services_name;

  // === TUTOR: no OTP at accept; call /tutor/:id/accept ===
  if (service === "Tutor Service") {
    try {

      // ✅ Use consistent balance + required commission logic
      const sc = currentServitor || servitor;
      const effectiveAvailable = getEffectiveAvailable(sc);
      const REQUIRED = getRequiredCommissionForAccept(order);

      if (effectiveAvailable - REQUIRED < MIN_AVAILABLE) {
        const need = (MIN_AVAILABLE + REQUIRED) - effectiveAvailable;
        setWarningInfo({ need: Math.max(0, Math.ceil(need)) });
        setShowWarningModal(true);
        return;
      }

      await axios.patch(
        `${URL}/tutor/${order.Id}/accept`,
        { servitor_id: servitorId },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );

      // (optional) refresh servitor balances in UI
      const updatedServitorResponse = await axios.get(`${URL}/servitors/${servitorId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      setCurrentServitor(updatedServitorResponse.data);

      setPin("");                 // no OTP yet for tutor
      setIsPinVerified(false);
      setShowSuccessModal(true);  // "accepted" success
      return;
    } catch (error) {
      console.error("Error accepting tutor order:", error);
      setErrorModalMessage(t("viewOrderDetails.orderAcceptFailed"));
      setShowErrorModal(true);
      return;
    }
  }

  // === NON-TUTOR: use backend snapshot commission/platform fee (new system) ===
  const sc = currentServitor || servitor;
  const effectiveAvailable = getEffectiveAvailable(sc);
  const estimatedCommission = getRequiredCommissionForAccept(order);

  if (effectiveAvailable - estimatedCommission < MIN_AVAILABLE) {
    const need = (MIN_AVAILABLE + estimatedCommission) - effectiveAvailable;
    setWarningInfo({ need: Math.max(0, Math.ceil(need)) });
    setShowWarningModal(true);
    return;
  }

  try {
    // generate prefixed OTP for non-tutor services
    let prefix = "";
    if (service === "Home Cleaning") prefix = "hs";
    else if (service === "Electrician") prefix = "es";
    else if (service === "Plumber") prefix = "ps";
    else if (service === "Gas Chula") prefix = "gs";
    else if (service === "AC Service") prefix = "as";
    else if (service === "Filter") prefix = "fs";
    else {
      alert(t("viewOrderDetails.cancelNotAllowed"));
      return;
    }
    const randomDigits = Math.floor(1000 + Math.random() * 9000).toString();
    const generatedPin = prefix + randomDigits;

    // build endpoint by service
    let endpoint = "";
    if (service === "Home Cleaning") endpoint = `${URL}/homeclean/${order.Id}`;
    else if (service === "Electrician") endpoint = `${URL}/electrician/${order.Id}`;
    else if (service === "Plumber") endpoint = `${URL}/plumber/${order.Id}`;
    else if (service === "Gas Chula") endpoint = `${URL}/gaschula/${order.Id}`;
    else if (service === "AC Service") endpoint = `${URL}/acservice/${order.Id}`;
    else if (service === "Filter") endpoint = `${URL}/filter/${order.Id}`;

    await axios.patch(
      endpoint,
      { status: "Accepted", servitor_id: servitorId, verification_pin: generatedPin },
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );

    const updatedServitorResponse = await axios.get(`${URL}/servitors/${servitorId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    });
    setCurrentServitor(updatedServitorResponse.data);

    // setPin(generatedPin);
    setPin("");
    setIsPinVerified(false);
    setShowSuccessModal(true);
  } catch (error) {
    console.error("Error accepting order:", error);
    if (error.response?.status === 409) setErrorModalMessage(t("viewOrderDetails.orderAlreadyAccepted"));
    else if (error.response?.status === 404) setErrorModalMessage(t("viewOrderDetails.orderNotAvailable"));
    else setErrorModalMessage(t("viewOrderDetails.orderAcceptFailed"));
    setShowErrorModal(true);
  }
};


// ------------ Tutor service new -------------- //
  const handleSubmitPin = async () => {
  if (!pin.trim()) {
    setVerificationError(t("viewOrderDetails.enterPinPlaceholder"));
    return;
  }
  try {
    const servitorId =
      servitor?.Id ||
      servitor?.id ||
      order.Servitor?.Id ||
      order.Servitor?.id;

    const response = await axios.patch(
      `${URL}/orders/${order.Id}/verify-pin`,
      { pin, servitor_id: servitorId, serviceType: order.Service?.services_name },
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );

    if (response.data.success) {
      setIsPinVerified(true);
      setShowSuccessModal(true);
    } else {
      setVerificationError(response.data.message || t("viewOrderDetails.invalidPin"));
    }
  } catch (error) {
    const status = error.response?.status;
    const data   = error.response?.data || {};

    // >>> Place the refresh here, after showing the blocked modal
    if (status === 403 && (data.errorType === "account_blocked" || /blocked/i.test(data.message || ""))) {
      setShowBlockedModal(true);
      setBlockedMessage(
        t("viewOrderDetails.accountBlockedMessage", { supportName: "HelpNao" })
      );
      setVerificationError("");

      // REFRESH SERVITOR PROFILE (so approve_status = "Blocked" in UI)
      try {
        const updated = await axios.get(
          `${URL}/servitors/${servitor?.Id || servitor?.id}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        setCurrentServitor(updated.data);
      } catch (e) {
        // swallow
      }

      return; // <<< important
    }
    // <<< end of blocked branch

    if (status === 400) {
      const tries = Number(data.attemptsRemaining ?? 0);
      if (Number.isFinite(tries) && tries >= 0) {
        setVerificationError(
          tries > 0
            ? t("viewOrderDetails.invalidPinWithTries", { tries })
            : t("viewOrderDetails.invalidPin")
        );
      } else {
        setVerificationError(data.message || t("viewOrderDetails.invalidPin"));
      }
      return;
    }

    const msg = data?.message;
    if (msg && msg.toLowerCase().includes("not approved")) {
      setVerificationError(
        t("viewOrderDetails.tutorNotApprovedYet") ||
        "User has not approved this tutor yet. Ask the customer to approve first."
      );
      return;
    }

    setVerificationError(t("viewOrderDetails.invalidPin"));
  }
};

// const refreshServitor = async () => {
//   try {
//     const updated = await axios.get(
//       `${URL}/servitors/${servitor?.Id || servitor?.id}`,
//       { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
//     );
//     setCurrentServitor(updated.data);
//   } catch {}
// };



  // const handleModalOk = () => {
  //   setShowSuccessModal(false);
  //   window.location.reload();
  //   // navigate('/servitor');
  // };

  const handleModalOk = () => {
  setShowSuccessModal(false);
  // window.location.reload(); 
  refreshOrder();            //  refresh order data
  refreshServitor?.();       //  refresh servitor header/balance if needed
};


  // const handleErrorModalOk = () => {
  //   setShowErrorModal(false);
  //   navigate("/servitor");
  //   window.location.reload();
  // };

  const handleErrorModalOk = () => {
    setShowErrorModal(false);
    navigate("/servitor");
    // window.location.reload(); //  not needed
  };


  const getOrderCity = (order) => {
    // return order.City || order.usercity || "Unknown";
    return order.City || order.usercity || t("viewOrderDetails.notProvided");
  };

  const getOrderArea = (order) => {
    // return order.City || order.usercity || "Unknown";
    return order.Area || order.userarea || t("viewOrderDetails.notProvided");
  };

  const getOrderAddress = (order) => {
    // return order.Address || order.useraddress || "Unknown";
    return order.Address || order.useraddress || t("viewOrderDetails.notProvided");
  };

  // Instead of immediate alert, open the cancel confirmation modal.
  const handleCancelOrder = () => {
    // Only allow cancellation if order is Accepted or In-Progress
    if (order.status === "Accepted" || order.status === "In-Progress") {
      setShowCancelModal(true);
    } else {
      // alert("Cancellation is not allowed at this stage.");
      alert(t("viewOrderDetails.cancelNotAllowed"));
    }
  };

  const handleConfirmCancel = async () => {

    // Validate feedback selection
    if (!selectedFeedbackOption) {
      setFeedbackError(t("viewOrderDetails.feedbackError.selectFeedback"));
      return;
    }

    // If "other", ensure textarea is not empty
    if (selectedFeedbackOption === "other" && !otherFeedback.trim()) {
      setFeedbackError(t("viewOrderDetails.feedbackError.writeFeedback"));
      return;
    }

    // Get final feedback
    const finalFeedback = selectedFeedbackOption === "other"
      ? otherFeedback
      : feedbackOptions.find((opt) => opt.id === selectedFeedbackOption)?.label || "";

    try {
      const servitorId =
        servitor?.Id ||
        servitor?.id ||
        order.Servitor?.Id ||
        order.Servitor?.id;
      // const cancelEndpoint = `http://localhost:4001/orders/${order.Id}/cancel`;
      const cancelEndpoint = `${URL}/orders/${order.Id}/cancel`;
      await axios.patch(cancelEndpoint, {
        serviceType: order.Service?.services_name,
        cancellation_feedback: finalFeedback,
        penalty: 50,
        servitor_id: servitorId,
      }, 
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      // console.log("Order cancelled:", cancelEndpoint);
      setShowCancelModal(false);
      setShowCancelSuccessModal(true);
    } catch (error) {
      console.error("Error cancelling order:", error);
      alert("Failed to cancel order. Please try again.");
      setShowCancelModal(false);

      // setErrorModalMessage(
      //   error.response?.data?.message ||
      //     "Failed to cancel order. Please try again."
      // );
      setErrorModalMessage(
        error.response?.data?.message || t("viewOrderDetails.orderAcceptFailed") // NEW: Translated
      );
      setShowErrorModal(true);
    }
  };

    const feedbackOptions = [
    {
      id: "customer_unavailable",
      label: t("viewOrderDetails.feedbackOptions.customerUnavailable"),
      // icon: "🚫",
      icon: <FaUserSlash />,
      bgColor: "#FEE2E2",
      borderColor: "#FECACA",
      textColor: "#991B1B",
    },
    {
      id: "personal_emergency",
      label: t("viewOrderDetails.feedbackOptions.personalEmergency"),
      // icon: "⚠️",
      icon: <FaAmbulance />,
      bgColor: "#FEF3C7",
      borderColor: "#FDE68A",
      textColor: "#92400E",
    },
    {
      id: "service_mismatch",
      label: t("viewOrderDetails.feedbackOptions.serviceMismatch"),
      // icon: "🔧",
      icon: <FaTools />,
      bgColor: "#DBEAFE",
      borderColor: "#BFDBFE",
      textColor: "#1E3A8A",
    },
    {
      id: "location_issue",
      label: t("viewOrderDetails.feedbackOptions.locationIssue"),
      // icon: "📍",
      icon: <FaMapMarkerAlt />,
      bgColor: "#E0F2FE",
      borderColor: "#BAE6FD",
      textColor: "#0C4A6E",
    },
    {
      id: "other",
      label: t("viewOrderDetails.feedbackOptions.other"),
      // icon: "✍️",
      icon: <FaPen />,
      bgColor: "#F3F4F6",
      borderColor: "#E5E7EB",
      textColor: "#374151",
    },
  ];

  // Handler for closing cancel modal without confirming
  const handleCancelModalClose = () => {
    setShowCancelModal(false);
  };



  /* ----------------------------- pricing key maps ----------------------------- */
// Electrician: boolean flat field name
const ELEC_BOOL_FLAT = { Electrical_checkup: "checkupFlat" };

// Plumber
const MAP_PLUMBER = {
  angle_valve_setup: "angleValveSetup",
  basin_tap_setup: "basinTapSetup",
  magic_pipe_setup: "magicPipeSetup",
  basin_waste_pop_up_setup: "basinWastePopUpSetup",
  new_basin_setup_existing_lines: "newBasinSetupExistingLines",

  bathroom_tap_bib_cock_setup: "bathroomTapBibCockSetup",
  tissue_holder_setup: "tissueHolderSetup",
  fill_valve_replacement: "fillValveReplacement",
  hand_shower_setup: "handShowerSetup",
  soap_dish_setup: "soapDishSetup",
  bathroom_shelf_setup: "bathroomShelfSetup",
  mirror_setup: "mirrorSetup",
  towel_hanger_setup: "towelHangerSetup",
  shower_head_setup: "showerHeadSetup",
  concealed_stopcock_setup: "concealedStopcockSetup",
  floor_drain_net_setup: "floorDrainNetSetup",

  toilet_seat_cover_replacement: "toiletSeatCoverReplacement",
  toilet_seat_complete_installation: "toiletSeatCompleteInstallation",
  high_commode_installation_existing_lines: "highCommodeInstallationExistingLines",
  blockage_clearing_high_commode: "blockageClearingHighCommode",
  blockage_clearing_low_commode: "blockageClearingLowCommode",

  bathroom_drain_line_cleaning: "bathroomDrainLineCleaning",
  geyser_installation: "geyserInstallation",

  kitchen_sink_setup_existing_lines: "kitchenSinkSetupExistingLines",
  sink_blockage_cleaning: "sinkBlockageCleaning",
  washing_machine_point_setup: "washingMachinePointSetup",
};
const PLUMBER_BOOL_FLAT = { issue_checkup: "issueCheckupFlat" };

// Gas Chula
const MAP_GAS = {
  NewchulaSetup: "newChulaSetup",
  chulaSetup: "chulaSetup",
  burnerSetup: "burnerSetup",
  burnerCleaning: "burnerCleaning",
  nozzleReplacement: "nozzleReplacement",
};
const GAS_BOOL_FLAT = { checkIssues: "checkIssuesFlat" };

// Filter
const MAP_FILTER = {
  new_filter_setup: "newFilterSetup",
  installation_filter: "installationFilter",
  uninstallation_filter: "uninstallationFilter",
  kit_replacement: "kitReplacement",
  pipe_leak_or_replace: "pipeLeakOrReplace",
  full_servicing: "fullServicing",
};
const FILTER_BOOL_FLAT = { check_up: "checkupFlat" };

// Home Cleaning (first-free vs per-unit groups)
const MAP_HOME_FIRSTFREE = { bed: "bedrooms", kitchen: "kitchens", dra_din: "drawingdinning" };
const MAP_HOME_PERUNIT   = {
  bath: "bathrooms", cloth: "cloths", dish: "dishes", balcony: "balconies",
  window_grill: "windowGrills", furniture_cleaning: "furniture",
  stairs_and_railing: "stairsFloors", carpet_cleaning: "carpets",
};

/* ----------------------------- money & AC helpers ----------------------------- */
const money = (n) => `৳${Number(n || 0).toLocaleString("en-BD")}`;

// AC rule: if qty===1 -> use `first`; if qty>=2 -> ALL units at `additional`
const acPerUnitCost = (prop, qty) => {
  const c = Math.max(0, Number(qty) || 0);
  if (!c) return { total: 0, text: "" };
  const rate = AC_PRICING?.perUnit?.[prop];
  if (!rate) return { total: 0, text: "" };

  if (c === 1) {
    return { total: rate.first, text: `1 × ${rate.first}` };
  }
  const total = c * rate.additional;
  return { total, text: `${c} × ${rate.additional}` };
};

// AC checkup: base covers up to `includesUnits`, extras are `extraPerUnit`
const acCheckupCost = (qty) => {
  const c = Math.max(0, Number(qty) || 0);
  if (!c) return { total: 0, text: "" };
  const { base = 0, includesUnits = 0, extraPerUnit = 0 } = AC_PRICING.checkup || {};
  if (c <= includesUnits) {
    return { total: base, text: `${c} unit${c > 1 ? "s" : ""} — ${base}` };
  }
  const over = c - includesUnits;
  return { total: base + over * extraPerUnit, text: `${includesUnits} — ${base} + ${over} × ${extraPerUnit}` };
};


 

  // *** Updated renderServiceDetails function for has value Highlight ***

//   const renderServiceDetails = () => {
//   // 1) helper to decide whether to show a value
//   const hasValue = (value) => {
//     if (typeof value === "number") return value > 0;
//     if (typeof value === "string") return value.toLowerCase() === "yes";
//     return !!value;
//   };

//   // 2) helper to format (unit pluralization, booleans)
//   const formatValue = (value, isBoolean = false) => {
//     if (isBoolean)     return value ? "Yes" : "No";
//     if (typeof value === "number") {
//       return value === 1
//         ? `1 ${t("viewOrderDetails.unit")}`
//         : `${value} ${t("viewOrderDetails.units")}`;
//     }
//     return value;
//   };

//   // 3) Find the list of fields for this service
//   const serviceName = order.Service?.services_name;
//   const fields     = serviceFields[serviceName] || [];

//   // 4) Derive the translation key segment ("homeCleaning", "plumber", ...)
//   const keyMap = {
//     "Home Cleaning": "homeCleaning",
//     Plumber:         "plumber",
//     Electrician:     "electrician",
//     "Gas Chula":     "gasChula",
//     "AC Service":    "acService",
//     Filter:          "filter",
//     "Tutor Service": "tutor",
//   };
//   const skey = keyMap[serviceName] || "";

//   // 5) Title lookup: e.g. t("viewOrderDetails.services.homeCleaning.title")
//   const title = t(`viewOrderDetails.services.${skey}.title`);

//   return (
//     <div className="service-details-card">
//       <h3>{title}</h3>
//       <div className="service-info-grid">
//         {fields.map(({ prop, labelKey, type }, i) => {
//           const raw = order[prop];
//           // skip empty/zero/false
//           if (type === "number"  && Number(raw) === 0) return null;
//           if (type === "text"    && !raw)             return null;
//           if (type === "boolean" && !raw)             return null;

//           // compute display value
//           const display = type === "boolean"
//             ? formatValue(raw, true)
//             : type === "number"
//               ? formatValue(raw)
//               : raw;

//           return (
//             <div
//               key={i}
//               className={`detail-box ${hasValue(raw) ? "has-value" : ""}`}
//             >
//               <div className="detail-label">{t(labelKey)}</div>
//               <div className="detail-value">{display}</div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };


const renderServiceDetails = () => {
  // unit label helper
  const u = (n) =>
    Number(n) === 1 ? t("viewOrderDetails.unit") : t("viewOrderDetails.units");

  // service context
  const serviceName = order.Service?.services_name;
  const fields = serviceFields[serviceName] || [];
  const svcPricing = SERVICE_PRICING[serviceName] || {};

  const keyMap = {
    "Home Cleaning": "homeCleaning",
    Plumber: "plumber",
    Electrician: "electrician",
    "Gas Chula": "gasChula",
    "AC Service": "acService",
    Filter: "filter",
    "Tutor Service": "tutor",
  };
  const skey = keyMap[serviceName] || "";
  const title = t(`viewOrderDetails.services.${skey}.title`);

  // --- pricing text + totals for each field (null if not billable) ---
  const getPriceInfo = (prop, type, raw) => {
    // skip empties
    if (type === "number" && Number(raw) === 0) return null;

    // ELECTRICIAN
    if (serviceName === "Electrician") {
      if (typeof raw === "boolean") {
        if (!raw) return null;
        const flatKey = ELEC_BOOL_FLAT[prop];
        const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
        if (!flat) return null;
        return { total: flat, text: `1 ${u(1)} × ${flat}` };
      }
      const qty = Number(raw || 0);
      if (qty <= 0) return null;
      const rate = svcPricing?.perUnit?.[prop];
      // if (!Number.isFinite(rate)) return null;
      // return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
      if (typeof rate === "number") {
        if (!Number.isFinite(rate) || rate <= 0) return null;
        return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
      }

      // drill-hole style pricing: { first, additional }
      if (rate && typeof rate === "object") {
        const first = Number(rate.first ?? 0);
        const additional = Number(rate.additional ?? rate.first ?? 0);
        if (!first && !additional) return null;

        const total = first + Math.max(0, qty - 1) * additional;

        const text =
          qty === 1
            ? `1 ${u(1)} × ${first}`
            : `1 ${u(1)} × ${first} + (${qty - 1} ${u(qty - 1)} × ${additional})`;

        return { total, text };
      }

      return null;
    }

    // PLUMBER
    if (serviceName === "Plumber") {
      if (typeof raw === "boolean") {
        if (!raw) return null;
        const flatKey = PLUMBER_BOOL_FLAT[prop];
        const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
        if (!flat) return null;
        return { total: flat, text: `1 ${u(1)} × ${flat}` };
      }
      const qty = Number(raw || 0);
      if (qty <= 0) return null;
      const puKey = MAP_PLUMBER[prop];
      const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
      if (!rate) return null;
      return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
    }

    // GAS CHULA
    if (serviceName === "Gas Chula") {
      if (typeof raw === "boolean") {
        if (!raw) return null;
        const flatKey = GAS_BOOL_FLAT[prop];
        const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
        if (!flat) return null;
        return { total: flat, text: `1 ${u(1)} × ${flat}` };
      }
      const qty = Number(raw || 0);
      if (qty <= 0) return null;
      const puKey = MAP_GAS[prop];
      const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
      if (!rate) return null;
      return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
    }

    // FILTER
    if (serviceName === "Filter") {
      if (typeof raw === "boolean") {
        if (!raw) return null;
        const flatKey = FILTER_BOOL_FLAT[prop];
        const flat = flatKey ? svcPricing?.[flatKey] || 0 : 0;
        if (!flat) return null;
        return { total: flat, text: `1 ${u(1)} × ${flat}` };
      }
      const qty = Number(raw || 0);
      if (qty <= 0) return null;
      const puKey = MAP_FILTER[prop];
      const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
      if (!rate) return null;
      return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
    }

    // HOME CLEANING
    if (serviceName === "Home Cleaning") {
      const qty = Number(raw || 0);
      if (qty <= 0) return null;

      // first-free group
      const ffKey = MAP_HOME_FIRSTFREE[prop];
      if (ffKey && svcPricing?.firstFree?.[ffKey]) {
        const perAdditional = svcPricing.firstFree[ffKey].perAdditional || 0;
        const chargeable = Math.max(0, qty - 1);
        const text =
          chargeable > 0
            ? `${chargeable} ${u(chargeable)} × ${perAdditional} (1st included)`
            : `0 ${u(0)} × ${perAdditional} (1st included)`;
        return { total: chargeable * perAdditional, text };
      }

      // straight per-unit
      const puKey = MAP_HOME_PERUNIT[prop];
      const rate = puKey ? svcPricing?.perUnit?.[puKey] || 0 : 0;
      if (!rate) return null;
      return { total: qty * rate, text: `${qty} ${u(qty)} × ${rate}` };
    }

    // AC SERVICE (use helpers so they’re not “unused”)
    if (serviceName === "AC Service") {
      if (
        [
          "installation_outdoor_inside",
          "installation_outdoor_outside",
          "uninstallation_outdoor_inside",
          "uninstallation_outdoor_outside",
          "cleaning_outdoor_inside",
          "cleaning_outdoor_outside",
        ].includes(prop)
      ) {
        const qty = Number(raw || 0);
        if (qty <= 0) return null;
        return acPerUnitCost(prop, qty); // -> { total, text }
      }

      if (prop === "issue_checkup") {
        const qty = Number(raw || 0);
        if (qty <= 0) return null;
        return acCheckupCost(qty); // -> { total, text }
      }

      // descriptors (acType, acTon, remarks) are non-billable
      return null;
    }

    return null;
  };

  return (
    <div className="service-details-card">
      <h3>{title}</h3>
      <div className="service-info-grid">
        {fields.map(({ prop, labelKey, type }, i) => {
          const raw = order[prop];

          // skip empty
          if (type === "number" && Number(raw) === 0) return null;
          if (type === "text" && !raw) return null;
          if (type === "boolean" && !raw) return null;

          const priceInfo = getPriceInfo(prop, type, raw); // { total, text } | null

          return (
            <div key={i} className={`detail-box ${priceInfo ? "has-value" : ""}`}>
              <div className="detail-label">{t(labelKey)}</div>

              {priceInfo ? (
                <div className="detail-price">
                  {priceInfo.text} = <strong>{money(priceInfo.total)}</strong>
                </div>
              ) : (
                <div className="detail-value">
                  {type === "boolean" ? (raw ? "Yes" : "No") : String(raw)}
                </div>
              )}
            </div>
          );
        })}

        {/* Custom services (from custom_service_json) */}
        {getCustomItems(order).map((c, idx) => {
          const name = String(c?.name || "").trim();
          const price = Number(c?.price || 0);
          if (!name) return null;

          return (
            <div key={`custom-${idx}`} className="detail-box has-value">
              <div className="detail-label">Custom Service</div>
              <div className="detail-price">
                {name} = <strong>{money(price)}</strong>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};



  // const [showReviewModal, setShowReviewModal] = useState(false);
  const handleOpenReviewModal = () => setShowReviewModal(true);
  const handleCloseReviewModal = () => setShowReviewModal(false);

  // if (error) return <p>{error}</p>;
  // if (!order) return <p>Loading order details...</p>;

  return (
    <div className="container">
      <Loader show={loading} />
      {showSessionExpiredModal && <SessionExpiredModal />}
      { !loading && error && !showSessionExpiredModal && <p>{error}</p>}
      {/* {!error && !order && <p>Loading order details...</p>} */}
      {/* {!error && !order && <p>{t("viewOrderDetails.loading")}</p>} */}
      {order && (
        <>
          <div className="header">
            {/* <h2>Order Details</h2> */}
            <h2>{t("viewOrderDetails.heading")}</h2>
            {/* <span className="order-id">Order ID: {order.Id}</span> */}
            {/* <span className="order-id">Order Number: {order.order_number}</span> */}

            <span className="order-id">
              {t("viewOrderDetails.orderNumber")}: {order.order_number}
            </span>
          </div>

          <div className="servitororderview-main-content">
            <div className="card customer-info">
              {/* <h3>Customer Information</h3> */}
              <h3>{t("viewOrderDetails.customerInfo")}</h3>
              <div className="info-content">
                <div className="info-row">
                  {/* <span>Name: </span> */}
                  <span>{t("viewOrderDetails.name")}: </span>
                  <span>{`${order.User?.FirstName || "Not provided"} ${
                    order.User?.LastName || ""
                  }`}</span>
                </div>
                {/* <div className="info-row">
                  <span>{t("viewOrderDetails.mobile")}: </span>
                  <span>{order.User?.mobile || "Not provided"}</span>
                </div> */}

                <div className="info-row">
                  <span>{t("viewOrderDetails.mobile")}: </span>

                  {canViewPhone && order?.User?.mobile ? (
                    <span className="phone-cell">
                      <span className="phone-number">{order.User.mobile}</span>
                      <a
                        className="call-btn"
                        href={`tel:${normalizeTel(order.User.mobile)}`}
                        aria-label={t("viewOrderDetails.callCustomer")}
                        title={t("viewOrderDetails.callCustomer")}
                      >
                        <FaPhoneAlt />
                        <span className="call-text">{t("viewOrderDetails.call")}</span>
                      </a>
                    </span>
                  ) : (
                    <span className="phone-hidden">
                      <FaLock className="lock-icon" />
                      <span className="phone-hidden-text">
                        {t("viewOrderDetails.phoneHiddenUntilAccept")}
                      </span>
                    </span>
                  )}
                </div>


                <div className="info-row">
                  {/* <span>City: </span> */}
                  <span>{t("viewOrderDetails.city")}: </span>
                  <span>{getOrderCity(order) || "Not provided"}</span>
                </div>
                <div className="info-row">
                  {/* <span>City: </span> */}
                  <span>{t("viewOrderDetails.area")}: </span>
                  <span>{getOrderArea(order) || "Not provided"}</span>
                </div>
                <div className="info-row">
                  {/* <span>Address: </span> */}
                  <span>{t("viewOrderDetails.address")}: </span>
                  <span>{getOrderAddress(order) || "Not provided"}</span>
                </div>
              </div>
            </div>

            <div className="card order-info">
              {/* <h3>Order Information</h3> */}
              <h3>{t("viewOrderDetails.orderInfo")}</h3>
              <div className="info-content">
                <div className="info-row">
                  {/* <span>Service: </span> */}
                  <span>{t("viewOrderDetails.service")}: </span>
                  <span>{order.Service?.services_name}</span>
                </div>
                <div className="info-row">
                  {/* <span>Price: </span> */}
                  <span>{t("viewOrderDetails.price")}: </span>
                  <span className="price">{order.price} Tk.</span>
                </div>
                <div className="info-row">
                  {/* <span>Date: </span> */}
                  <span>{t("viewOrderDetails.date")}: </span>
                  {/* <span>{new Date(order.date).toLocaleDateString()}</span> */}
                  <span>{formatDate(order.date)}</span>
                </div>
                <div className="info-row">
                  {/* <span>Time: </span> */}
                  <span>{t("viewOrderDetails.time")}: </span>
                  <span>{order.time}</span>
                </div>
                <div className="info-row">
                  {/* <span>Status: </span> */}
                  <span>{t("viewOrderDetails.status")}: </span>
                  <span className={`status-badge ${order.status}`}>
                    {order.status}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {renderServiceDetails()}

          {/* {order.remarks && (
            <div className="remarks-section">
              <FaRegCommentDots className="remarks-icon" />
              <span className="remarks-label">
                {t("viewOrderDetails.remarks")}:
              </span>
              <span className="remarks-text">{order.remarks}</span>
            </div>
          )} */}

          {order.remarks && (
            <div className="remarks-card">
              <FaRegCommentDots className="remarks-icon" />
              <p className="remarks-text">
                <strong>{t("viewOrderDetails.remarks")}: </strong>
                {order.remarks}
              </p>
            </div>
          )}

          {isTutor && order.status === "Accepted" && !order.user_approved && (
            <div className="notice-card">
              {/* {t("viewOrderDetails.tutorAwaitingApproval") ||
                "Waiting for user approval. OTP will be generated after the user approves you."} */}
                Waiting for user approval. OTP will be generated after the user approves you.
            </div>
          )}


          {/* When order status is Accepted, show the PIN verification card */}
          {order.status === "Accepted" && 
          (serviceName !== "Tutor Service" || order.user_approved) && (
            <div className="card verification-card">
              {/* <h3>Start Work Verification</h3> */}
              <h3>{t("viewOrderDetails.startWorkVerification")}</h3>
              {/* <p>
                Please enter the verification PIN provided to you to start the
                task.
              </p> */}
              <p>{t("viewOrderDetails.startWorkMessage")}</p>
              <input
                type="text"
                placeholder="Enter PIN"
                className="pin-input"
                value={pin}
                onChange={(e) => {
                  setPin(e.target.value);
                  setVerificationError("");
                }}
                aria-label={t("viewOrderDetails.enterPinPlaceholder")}
              />
              {verificationError && (
                <p style={{ color: "red" }}>{verificationError}</p>
              )}
              <button
                className="viewdetailsbtn submit-pin-btn"
                onClick={handleSubmitPin}
                aria-label={t("viewOrderDetails.submitPin")}
              >
                {/* Submit PIN */}
                {t("viewOrderDetails.submitPin")}
              </button>
            </div>
          )}

          <div className="actions">
            <button
              className="viewdetailsbtn back-btn"
              onClick={handleBack}
              aria-label={t("viewOrderDetails.backToOrders")}
            >
              {/* ← Back to Orders */}← {t("viewOrderDetails.backToOrders")}
            </button>
            {/* When order status is not Accepted, show Accept Order button; otherwise show View Print button */}
            {order.status === "pending" ? (
              <button
                className="viewdetailsbtn accept-btn"
                // onClick={handleAcceptOrder}
                onClick={() => {
                  // If servitor is busy then here show a modal message instead of accepting the order.
                  if (servitor.availability === "busy") {
                    setShowBusyModal(true);
                  } else {
                    handleAcceptOrder();
                  }
                }}
                aria-label={t("viewOrderDetails.acceptOrder")}
              >
                {/* Accept Order */}
                {t("viewOrderDetails.acceptOrder")}
              </button>
            ) : (
              <div
                className="action-buttons"
                style={{ display: "flex", gap: "10px" }}
              >
                <button
                  className="viewdetailsbtn print-btn"
                  onClick={() => setShowReceipt(true)}
                  // style={{
                  //   backgroundColor: "#007bff",
                  //   color: "#fff",
                  //   border: "none",
                  //   borderRadius: "4px",
                  //   padding: "10px 20px",
                  //   cursor: "pointer",
                  //   fontSize: "1rem",
                  //   transition: "background-color 0.3s ease",
                  // }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0069d9")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#007bff")
                  }
                  aria-label={t("viewOrderDetails.receipt")}
                >
                  {/* Print */}
                  <FaDownload style={{ marginRight: "8px" }} />
                  {/* Receipt */}
                  {t("viewOrderDetails.receipt")}
                </button>

                {/* Cancel button appears if order is Accepted or In-Progress */}
                {(order.status === "Accepted" ||
                  order.status === "In-Progress") && (
                  <button
                    className="viewdetailsbtn cancel-btn"
                    onClick={handleCancelOrder}
                    style={{
                      backgroundColor: "#e74c3c",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      padding: "10px 20px",
                      cursor: "pointer",
                      fontSize: "1rem",
                      transition: "background-color 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#c0392b")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#e74c3c")
                    }
                    aria-label={t("viewOrderDetails.cancel")}
                  >
                    {/* Cancel */}
                    {t("viewOrderDetails.cancel")}
                  </button>
                )}
              </div>
            )}

            {/* If order is completed, show a Review & Feedback button for the servitor and check review is given or not*/}
            {order.status === "Completed" && !order.hasReview && (
              <button
                className="viewdetailsbtn review-btn"
                onClick={handleOpenReviewModal}
                aria-label={t("viewOrderDetails.rateCustomer")}
              >
                {/* Review & Feedback */}
                {/* Rate the Customer */}
                {t("viewOrderDetails.rateCustomer")}
              </button>
            )}

            {(order.status !== "pending") && ( 
            <button
              className="viewdetailsbtn help-btn"
              onClick={() =>
                navigate(`/servitor/support/report/${order.order_number}`, {
                  state: { serviceType: order.Service?.services_name },
                })
              }
            >
              <FaLifeRing style={{ marginRight: "8px" }} />
              {/* Help & Support */}
              {t("viewOrderDetails.help_support") || "Help & Support"}
            </button>
            )}

          </div>

          {/* Busy modal  */}
          {showBusyModal && (
            <div className="servitorViewOrder-modal-overlay">
              <div className="servitorViewOrder-modal-content">
                {/* <h3>Task In Progress</h3> */}
                <h3>{t("viewOrderDetails.taskInProgressTitle")}</h3>
                {/* <p>
                  You are already working on an order. Please complete your
                  current task to accept a new order.
                </p> */}

                <p>{t("viewOrderDetails.taskInProgressMessage")}</p>

                <button
                  className="viewdetailsbtn ok-btn"
                  onClick={() => setShowBusyModal(false)}
                  aria-label={t("viewOrderDetails.ok")}
                >
                  {/* OK */}
                  {t("viewOrderDetails.ok")}
                </button>
              </div>
            </div>
          )}

          {showErrorModal && (
            <div className="servitorViewOrder-modal-overlay">
              <div className="servitorViewOrder-modal-content">
                {/* <h3>Order Unavailable</h3> */}
                <h3>{t("viewOrderDetails.orderUnavailableTitle")}</h3>
                <p>{errorModalMessage}</p>
                <button
                  className="viewdetailsbtn ok-btn"
                  onClick={handleErrorModalOk}
                  aria-label={t("viewOrderDetails.ok")}
                >
                  {/* OK */}
                  {t("viewOrderDetails.ok")}
                </button>
              </div>
            </div>
          )}

          {showSuccessModal && (
            <div className="servitorViewOrder-modal-overlay">
              <div className="servitorViewOrder-modal-content">
                {/* <h3>Success</h3> */}
                <h3>{t("viewOrderDetails.successTitle")}</h3>
                {/* <p>Order ID {acceptedOrderId} has been accepted.</p> */}
                <p>
                  {/* {t("viewOrderDetails.successMessage", {
                    // orderId: acceptedOrderId,
                    orderNumber: order?.order_number || "N/A",
                  })} */}
                  {t(
                      isPinVerified
                        ? "viewOrderDetails.successMessagePinVerified"
                        : "viewOrderDetails.successMessage",
                      {
                        orderNumber: order?.order_number || "N/A",
                      }
                    )}
                </p>

                <button
                  className="viewdetailsbtn ok-btn"
                  onClick={handleModalOk}
                  aria-label={t("viewOrderDetails.ok")}
                >
                  {/* OK */}
                  {t("viewOrderDetails.ok")}
                </button>
              </div>
            </div>
          )}

          {/* Cancel Confirmation Modal */}
          {showCancelModal && (
            <div className="servitorViewOrderDetails-cancelation-modal-overlay">
              <div className="servitorViewOrderDetails-cancelation-modal-content">
                <h3 className="servitorViewOrderDetails-cancelation-modal-title">
                  {t("viewOrderDetails.confirmCancellationTitle")}
                </h3>
                {/* <p className="servitorViewOrderDetails-cancelation-modal-message">
                  {t("viewOrderDetails.confirmCancellationMessage")}
                </p> */}

                <p className="servitorViewOrderDetails-cancelation-modal-message">
                  <span className="servitorViewOrderDetails-cancelation-warning-icon">
                    <FaExclamationTriangle />
                  </span>
                  <span>
                    <strong>{t("viewOrderDetails.warningLabel")}</strong>:{" "}
                    {t("viewOrderDetails.confirmCancellationMessage")}
                  </span>
                </p>

                <h4 className="servitorViewOrderDetails-cancelation-feedback-prompt">
                  {t("viewOrderDetails.feedbackPrompt")}
                </h4>

                {feedbackError && (
                  <div className="servitorViewOrderDetails-cancelation-error-text">
                    {feedbackError}
                  </div>
                )}

                <div className="servitorViewOrderDetails-cancelation-feedback-grid">
                  {feedbackOptions.slice(0, 4).map((option) => (
                    <label
                      key={option.id}
                      className={`servitorViewOrderDetails-cancelation-feedback-option ${
                        selectedFeedbackOption === option.id ? "selected" : ""
                      }`}
                      style={{
                        backgroundColor:
                          selectedFeedbackOption === option.id
                            ? option.bgColor
                            : "#fff",
                        borderColor:
                          selectedFeedbackOption === option.id
                            ? option.borderColor
                            : "#e5e7eb",
                        color:
                          selectedFeedbackOption === option.id
                            ? option.textColor
                            : "#374151",
                      }}
                      onClick={() => {
                        setSelectedFeedbackOption(option.id);
                        if (option.id !== "other") setOtherFeedback("");
                        setFeedbackError("");
                      }}
                    >
                      <input
                        type="radio"
                        name="feedback"
                        value={option.id}
                        checked={selectedFeedbackOption === option.id}
                        readOnly
                        className="servitorViewOrderDetails-cancelation-feedback-radio"
                      />
                      <span className="servitorViewOrderDetails-cancelation-option-icon">
                        {option.icon}
                      </span>
                      <span className="servitorViewOrderDetails-cancelation-option-label">
                        {option.label}
                      </span>
                    </label>
                  ))}
                </div>

                <label
                  className={`servitorViewOrderDetails-cancelation-feedback-option full-width ${
                    selectedFeedbackOption === "other" ? "selected" : ""
                  }`}
                  style={{
                    backgroundColor:
                      selectedFeedbackOption === "other"
                        ? feedbackOptions[4].bgColor
                        : "#fff",
                    borderColor:
                      selectedFeedbackOption === "other"
                        ? feedbackOptions[4].borderColor
                        : "#e5e7eb",
                    color:
                      selectedFeedbackOption === "other"
                        ? feedbackOptions[4].textColor
                        : "#374151",
                  }}
                  onClick={() => {
                    setSelectedFeedbackOption("other");
                    setFeedbackError("");
                  }}
                >
                  <input
                    type="radio"
                    name="feedback"
                    value="other"
                    checked={selectedFeedbackOption === "other"}
                    readOnly
                    className="servitorViewOrderDetails-cancelation-feedback-radio"
                  />
                  <span className="servitorViewOrderDetails-cancelation-option-icon">
                    {feedbackOptions[4].icon}
                  </span>
                  <span className="servitorViewOrderDetails-cancelation-option-label">
                    {feedbackOptions[4].label}
                  </span>
                </label>

                {selectedFeedbackOption === "other" && (
                  <div className="servitorViewOrderDetails-cancelation-other-feedback-container">
                    <label className="servitorViewOrderDetails-cancelation-other-feedback-label">
                      {t("viewOrderDetails.feedbackOtherDetails")}
                    </label>
                    <textarea
                      value={otherFeedback}
                      onChange={(e) => setOtherFeedback(e.target.value)}
                      placeholder={t(
                        "viewOrderDetails.feedbackOtherPlaceholder"
                      )}
                      className="servitorViewOrderDetails-cancelation-textarea"
                    />
                  </div>
                )}

                <div className="servitorViewOrderDetails-cancelation-modal-actions">
                  <button
                    className="viewdetailsbtn servitorViewOrderDetails-cancelation-modal-cancel-btn"
                    onClick={handleConfirmCancel}
                    aria-label={t("viewOrderDetails.yesCancel")}
                  >
                    {t("viewOrderDetails.yesCancel")}
                  </button>
                  <button
                    className="viewdetailsbtn servitorViewOrderDetails-cancelation-modal-back-btn"
                    onClick={handleCancelModalClose}
                    aria-label={t("viewOrderDetails.noGoBack")}
                  >
                    {t("viewOrderDetails.noGoBack")}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Warning Modal */}
          {showWarningModal && (
            <div className="servitorViewOrder-modal-overlay">
              <div className="servitorViewOrder-modal-content">
                {/* <h3 style={{ color: "orange" }}>Warning!</h3> */}
                <h3 style={{ color: "orange" }}>
                  {t("viewOrderDetails.warningTitle")}
                </h3>
                {/* <p>
                  Accepting this order will reduce your available balance below
                  the minimum required. Please top-up your account before
                  accepting more orders.
                </p> */}
                <p>{t("viewOrderDetails.warningMessage",{ need: moneyTk(warningInfo.need) })}</p>
                {/* {t("viewOrderDetails.warningCombined", { need: moneyTk(warningInfo.need) })} */}
                <button
                  className="viewdetailsbtn ok-btn"
                  onClick={() => setShowWarningModal(false)}
                >
                  {/* OK */}
                  {t("viewOrderDetails.ok")}
                </button>
              </div>
            </div>
          )}

          {/* Cancel Success Modal */}
          {showCancelSuccessModal && (
            <div className="servitorViewOrder-modal-overlay">
              <div className="servitorViewOrder-modal-content">
                {/* <h3>Cancellation Successful</h3> */}
                <h3>{t("viewOrderDetails.cancellationSuccessfulTitle")}</h3>
                {/* <p>Your order has been cancelled.</p> */}
                <p>{t("viewOrderDetails.cancellationSuccessfulMessage")}</p>
                <button
                  className="viewdetailsbtn ok-btn"
                  // onClick={() => window.location.reload()}
                  onClick={() => {
                    setShowCancelSuccessModal(false);
                    // window.location.reload(); // 
                    refreshOrder();            //  update order status
                    refreshServitor?.();       //  update balance/penalty etc.
                  }}

                  aria-label={t("viewOrderDetails.ok")}
                >
                  {/* OK */}
                  {t("viewOrderDetails.ok")}
                </button>
              </div>
            </div>
          )}

          {/* Review & Feedback Modal for servitor */}
          {showReviewModal && (
            <ServitorReviewModal
              order={order}
              onClose={handleCloseReviewModal}
              onReviewSubmit={() => {
                // After review submission, refresh the page or update UI accordingly.
                // window.location.reload();
                refreshOrder();
              }}
            />
          )}

          {showReceipt && (
            <ServitorReceiptGenerator
              order={order}
              onFinish={() => setShowReceipt(false)}
            />
          )}
        </>
      )}

      {showBlockedModal && (
        <div className="servitorViewOrder-modal-overlay">
          <div className="servitorViewOrder-modal-content">
            <h3 style={{ color: "#e74c3c" }}>{t("viewOrderDetails.accountBlockedTitle")}</h3>
            <p>{blockedMessage}</p>
            <button
              className="viewdetailsbtn ok-btn"
              onClick={() => {
                setShowBlockedModal(false);
                // Optional: navigate to support or profile
                // navigate("/servitor/support");
              }}
              aria-label={t("viewOrderDetails.ok")}
            >
              {t("viewOrderDetails.ok")}
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default ViewOrderDetails;